(function () {
  'use strict';
function createTCBundleEngine(messages={}) {
  const singleIds=[48946539397222,48946539429990,48946539331686,48946539364454];
  const systemIds=[45819234418790,45819234386022];
  const kitId=47048293613670;
  const kitProductId=8194543452262;
  const source='tc-order-kit',version='tc-order-kit-v1';
  const totals={1:6999,2:11900,3:16900};
  const fail=code=>{throw Error(messages[code]||code);};
  const totalFor=quantity=>{
    if(!Number.isSafeInteger(quantity)||quantity<0)fail('invalid_quantity');
    return quantity===0?0:quantity>=4?quantity*4975:totals[quantity];
  };
  const quantity=lines=>lines.reduce((sum,line)=>sum+Number(line.quantity),0);
  const facts=cart=>{
    const items=cart.items||[],singles=items.filter(line=>singleIds.includes(Number(line.variant_id))),systems=items.filter(line=>systemIds.includes(Number(line.variant_id))),kits=items.filter(line=>Number(line.variant_id)===kitId);
    const count=quantity(singles),systemCount=quantity(systems);
    return {singles,systems,kits,count,systemCount,eligible:count>=2||systemCount>0,expectedTotal:totalFor(count),actualTotal:singles.reduce((sum,line)=>sum+Number(line.final_line_price),0)};
  };
  const owned=line=>line.properties?._bs_kit_source===source&&line.properties?._bs_offer_version===version;
  const known=line=>owned(line)||(['preset-bundle','custom-pair','selector-vortex-pair'].includes(line.properties?._bs_kit_source)&&line.properties?._bs_offer_version==='preset-bundle-v1');
  const nativeZero=line=>(line.product_id==null||Number(line.product_id)===kitProductId)&&Number(line.original_price)===0&&Number(line.final_price)===0&&Number(line.final_line_price)===0;
  const hasLegacyParent=cart=>(cart.items||[]).some(line=>[44451453567078,45391169683558,45535715033190,42373983174758].includes(Number(line.variant_id))||line.properties?._bs_selector_setup==='two-vortex-kit');
  const handlesKit=cart=>{
    const f=facts(cart);
    return f.eligible||f.kits.some(owned)||(!hasLegacyParent(cart)&&f.kits.some(line=>line.properties?._bs_kit_source==='preset-bundle'));
  };
  const verifyPrice=cart=>{
    const f=facts(cart);
    if(f.count){
      if(cart.currency!=='USD')fail('currency');
      if(f.singles.some(line=>Number(line.original_price)!==6999))fail('price_changed');
      if(!Number.isSafeInteger(f.actualTotal)||f.actualTotal>f.expectedTotal)fail('price_missing');
    }
    return cart;
  };
  const verify=cart=>{
    verifyPrice(cart);
    const f=facts(cart);
    if(f.kits.some(line=>!known(line)||!nativeZero(line)))fail('kit_unknown');
    if(quantity(f.kits)>1)fail('kit_quantity');
    if(handlesKit(cart)){
      if(quantity(f.kits)!==(f.eligible?1:0))fail('kit_quantity');
    }
    return cart;
  };
  const capKnownKits=async(cart,io)=>{
    const f=facts(cart);
    if(f.kits.some(line=>!known(line)||!nativeZero(line)))fail('kit_unknown');
    if(quantity(f.kits)<=1)return cart;
    const selectorPresent=(cart.items||[]).some(line=>Number(line.variant_id)===44451453567078&&line.properties?._bs_selector_setup==='two-vortex-kit');
    const keep=(selectorPresent&&f.kits.find(line=>line.properties?._bs_kit_source==='selector-vortex-pair'))||f.kits.find(line=>line.properties?._bs_kit_source==='custom-pair')||f.kits[0];
    for(const line of f.kits){const next=line===keep?1:0;if(Number(line.quantity)!==next)await io.change(line.key,next);}
    return verify(await io.get());
  };
  const reconcile=async(cart,io)=>{
    verifyPrice(cart);
    if(!handlesKit(cart))return capKnownKits(cart,io);
    const f=facts(cart);
    if(f.kits.some(line=>!known(line)||!nativeZero(line)))fail('kit_unknown');
    const expected=f.eligible?1:0;
    const keep=f.kits.find(line=>['custom-pair','selector-vortex-pair'].includes(line.properties?._bs_kit_source))||f.kits[0];
    for(const line of f.kits){const next=expected&&line===keep?1:0;if(Number(line.quantity)!==next)await io.change(line.key,next);}
    if(expected&&!keep)await io.add([{id:kitId,quantity:1,properties:{_bs_kit_source:source,_bs_offer_version:version}}]);
    return verify(await io.get());
  };
  const groupedChoices=choices=>{
    if(!choices.length||choices.some(id=>!singleIds.includes(Number(id))))fail('choice_invalid');
    const result=new Map();for(const choice of choices){const id=Number(choice);result.set(id,(result.get(id)||0)+1);}
    return [...result].map(([id,quantity])=>({id,quantity}));
  };
  return {singleIds,systemIds,kitId,kitProductId,source,version,totalFor,facts,owned,known,nativeZero,handlesKit,verifyPrice,verify,capKnownKits,reconcile,groupedChoices};
}
  var tcBundleEngine=createTCBundleEngine({"invalid_quantity":"Choose an available number of pitchers.","currency":"This bundle needs a USD cart. Please review the store currency.","price_changed":"The pitcher price changed. Please review your bundle.","price_missing":"Shopify has not applied the bundle price. Please review the cart before checkout.","kit_unknown":"This cart contains another starter-kit offer. Please review it before checkout.","kit_quantity":"The one-per-order starter kit could not be verified.","choice_invalid":"Choose an available Vortex or EVO pitcher for every slot."});

  if (window.__BS_WHITE_CART_DRAWER__) return;
  window.__BS_WHITE_CART_DRAWER__ = true;
  window.__BS_CORE_PURCHASE_PATH_STAGING__ = true;

  var VERSION = 'owner-review-preset-real-kit-restore-2026-08-08.2';
  var OFFER_VERSION = 'preset-bundle-v1';
  var DRAWER_VERSION = 'concept-b-white-state-safe-1';
  var PITCHER_GUIDANCE_ENABLED = true;
  var PRESET_STARTER_KIT_ENABLED = true;
  var CUSTOM_PAIR_STARTER_KIT_ENABLED = true;
  // Keep the obsolete page-level custom-pair experiment dormant. The approved
  // implementation lives only in the shared white cart drawer.
  var CUSTOM_PAIR_PRODUCT_PAGE_SELECTOR_ENABLED = false;
  var ROUTES = {
    bundle: '/products/vortex-evo-latte-art-set',
    evo: '/products/evo-2-0-curvier-sturdier-sharper-480ml',
    vortex: '/products/vortex-high-velocity-milk-pitcher',
    selector: '/pages/choose-a-free-pitcher',
    cart: '/cart'
  };
  var PRESET_PRODUCT_ID = 7994001457254;
  var PRESET_VARIANTS = [45819234386022, 45819234418790];
  // The obsolete hidden-set conversion path remains unavailable. Zero sentinel
  // values prevent any failed staging resource from being referenced.
  var HIDDEN_SET_PRODUCT_ID = 0;
  var HIDDEN_SET_VARIANT_ID = 0;
  var HIDDEN_SET_PRICE = 11900;
  var HIDDEN_SET_SKU = 'CUSTOM-2PITCHER-KIT';
  var STARTER_KIT_TEXT = 'Barista Towel + 58.5mm Puck Screen + Latte Art Etching Pen';
  // Dedicated $0 fulfillment line for the EVO + Vortex preset bundle.
  // Kept separate from the $15 Vortex + Ultra Sharp paid add-on below.
  var STARTER_KIT_PRODUCT_ID = 8194543452262;
  var STARTER_KIT_VARIANT_ID = 47048293613670;
  var STARTER_KIT_REGULAR_PRICE = 4497;
  var PRESET_KIT_SOURCE = 'preset-bundle';
  var CUSTOM_PAIR_KIT_SOURCE = 'custom-pair';
  var VU_BUNDLE_PRODUCT_ID = 8019080675430;
  var VU_PAID_KIT_PRODUCT_ID = 8106969464934;
  var VU_PAID_KIT_VARIANT_ID = 45948588163174;
  var VU_PAID_KIT_SOURCE = 'vortex-ultra-sharp-paid-addon';
  var VU_PAID_KIT_PRICE = 1500;

  var SELECTOR_VORTEX_SETUP = 'two-vortex-kit';
  var SELECTOR_ULTRA_SETUP = 'vortex-ultra-kit';
  var SELECTOR_VORTEX_ID = 44451453567078;
  var SELECTOR_ULTRA_IDS = [45664124665958, 45664125419622];
  var SELECTOR_PAIR_KIT_SOURCE = 'selector-vortex-pair';
  var selectorCopy = {
    pairTitle: "2 Vortex + Starter Kit",
    ultraTitle: "3 Pitchers + Starter Kit",
    oddPair: "Vortex setup quantities must contain complete pairs. Please use the setup quantity control.",
    kitError: "The Starter Kit quantity could not be verified for this setup. Please refresh the cart."
  };

  function selectorSetup(line) {
    var setup = (line.properties || {})._bs_selector_setup;
    var id = Number(line.variant_id);
    if (setup === SELECTOR_VORTEX_SETUP && (id === SELECTOR_VORTEX_ID || id === STARTER_KIT_VARIANT_ID)) return setup;
    if (setup === SELECTOR_ULTRA_SETUP && (SELECTOR_ULTRA_IDS.indexOf(id) !== -1 || id === VU_PAID_KIT_VARIANT_ID)) return setup;
    return '';
  }

  function selectorParent(line) {
    var setup = selectorSetup(line);
    return setup && Number(line.variant_id) !== STARTER_KIT_VARIANT_ID && Number(line.variant_id) !== VU_PAID_KIT_VARIANT_ID;
  }

  function selectorGroups(cart) {
    var groups = [];
    (cart.items || []).forEach(function (line) {
      var setup = selectorSetup(line);
      if (!setup) return;
      var parentId = selectorParent(line) ? Number(line.variant_id) : Number((line.properties || {})._bs_parent_variant);
      var group = groups.find(function (item) { return item.setup === setup && item.parentId === parentId; });
      if (!group) { group = { setup: setup, parentId: parentId, parents: [], kits: [] }; groups.push(group); }
      (selectorParent(line) ? group.parents : group.kits).push(line);
    });
    groups.forEach(function (group) {
      group.units = group.parents.reduce(function (total, line) { return total + Number(line.quantity); }, 0);
      group.quantity = group.units / (group.setup === SELECTOR_VORTEX_SETUP ? 2 : 1);
      group.kitId = group.setup === SELECTOR_VORTEX_SETUP ? STARTER_KIT_VARIANT_ID : VU_PAID_KIT_VARIANT_ID;
      group.kitPrice = group.setup === SELECTOR_VORTEX_SETUP ? 0 : VU_PAID_KIT_PRICE;
      group.kitQuantity = group.kits.reduce(function (total, line) { return total + Number(line.quantity); }, 0);
      group.total = group.parents.concat(group.kits).reduce(function (total, line) { return total + Number(line.final_line_price); }, 0);
    });
    return groups;
  }

  function selectorKitProperties(group) {
    return {
      _bs_selector_setup: group.setup,
      _bs_kit_source: group.setup === SELECTOR_VORTEX_SETUP ? SELECTOR_PAIR_KIT_SOURCE : VU_PAID_KIT_SOURCE,
      _bs_offer_version: OFFER_VERSION,
      _bs_parent_product: String(group.setup === SELECTOR_VORTEX_SETUP ? 7076136255590 : VU_BUNDLE_PRODUCT_ID),
      _bs_parent_variant: String(group.parentId),
      _bs_offer_price: String(group.kitPrice)
    };
  }

  function selectorKitValid(line, group) {
    var props = line.properties || {};
    var expected = selectorKitProperties(group);
    return Number(line.variant_id) === group.kitId && Object.keys(expected).every(function (key) { return String(props[key]) === expected[key]; }) &&
      Number(line.original_price) === group.kitPrice && Number(line.final_price) === group.kitPrice &&
      Number(line.final_line_price) === Number(line.quantity) * group.kitPrice;
  }

  function verifySelectorKits(cart) {
    selectorGroups(cart).forEach(function (group) {
      if (!Number.isSafeInteger(group.quantity) || group.quantity < 0) throw new Error(selectorCopy.oddPair);
      if(tcBundleEngine.facts(cart).eligible&&group.setup===SELECTOR_VORTEX_SETUP)return;
      if (group.quantity && (group.kits.length !== 1 || group.kitQuantity !== (group.setup === SELECTOR_VORTEX_SETUP ? 1 : group.quantity) || !selectorKitValid(group.kits[0], group))) throw new Error(selectorCopy.kitError);
      if (!group.quantity && group.kitQuantity) throw new Error(selectorCopy.kitError);
    });
    return cart;
  }

  function reconcileSelectorKits(cart) {
    var updates = {};
    var adds = [];
    var increases = [];
    selectorGroups(cart).forEach(function (group) {
      if (!Number.isSafeInteger(group.quantity) || group.quantity < 0) throw new Error(selectorCopy.oddPair);
      if(tcBundleEngine.facts(cart).eligible&&group.setup===SELECTOR_VORTEX_SETUP)return;
      var valid = group.kits.length === 1 && selectorKitValid(group.kits[0], group);
      var requiredKitQuantity = group.setup === SELECTOR_VORTEX_SETUP ? (group.quantity > 0 ? 1 : 0) : group.quantity;
      if (valid) {
        if (group.kitQuantity < requiredKitQuantity) increases.push({ key: group.kits[0].key, quantity: requiredKitQuantity });
        else if (group.kitQuantity > requiredKitQuantity) updates[group.kits[0].key] = requiredKitQuantity;
      } else {
        group.kits.forEach(function (line) { updates[line.key] = 0; });
        if (requiredKitQuantity) adds.push({ id: group.kitId, quantity: requiredKitQuantity, properties: selectorKitProperties(group) });
      }
    });
    (cart.items || []).forEach(function (line) {
      if (selectorSetup(line) || !paidAddonKitMetadataValid(line)) return;
      var limit = paidAddonKitQuantityLimit(line, cart);
      if (limit > 0 && Number(line.quantity) > limit) updates[line.key] = limit;
    });
    return (Object.keys(updates).length ? updateCartLines(updates).then(getCart) : Promise.resolve(cart)).then(function (updated) {
      return increases.reduce(function (pending, increase) { return pending.then(function () { return lineChangeRequest(increase.key, increase.quantity); }); }, Promise.resolve(updated)).then(function () { return adds.length ? addCartItems(adds).then(getCart) : getCart(); });
    }).then(verifySelectorKits);
  }

  function selectorGroupUpdates(group, quantity) {
    var updates = {};
    group.parents.forEach(function (line, index) { updates[line.key] = index ? 0 : quantity * (group.setup === SELECTOR_VORTEX_SETUP ? 2 : 1); });
    group.kits.forEach(function (line, index) { updates[line.key] = index ? 0 : group.setup === SELECTOR_VORTEX_SETUP ? (quantity > 0 ? 1 : 0) : quantity; });
    return updates;
  }

  function selectorGroupChange(group, quantity) {
    if (quantity <= group.quantity) return updateCartLines(selectorGroupUpdates(group, quantity));
    var first = group.parents[0];
    var multiplier = group.setup === SELECTOR_VORTEX_SETUP ? 2 : 1;
    var target = Number(first.quantity) + quantity * multiplier - group.units;
    return lineChangeRequest(first.key, target).then(getCart).then(reconcileSelectorKits);
  }

  function selectorGroupForLine(line, cart) {
    return selectorGroups(cart).find(function (group) { return group.parents.some(function (parent) { return parent.key === line.key; }); });
  }

  var ELIGIBLE = [
    {
      productId: 7513953566822,
      variantId: 45535715033190,
      handle: 'evo-2-0-curvier-sturdier-sharper-480ml',
      product: 'EVO 2.0',
      option: 'Mirror Black',
      sku: 'EVO002',
      available: true,
      image: 'https://cdn.shopify.com/s/files/1/1347/3541/files/Mirror_Black_product_photo_5.png?v=1777218330'
    },
    {
      productId: 7513953566822,
      variantId: 42373983174758,
      handle: 'evo-2-0-curvier-sturdier-sharper-480ml',
      product: 'EVO 2.0',
      option: 'Mirror Multicolor',
      sku: 'EVO005',
      available: true,
      image: 'https://cdn.shopify.com/s/files/1/1347/3541/files/EVO_Multicolor_Product_Photo.png?v=1775749877'
    },
    {
      productId: 7076136255590,
      variantId: 44451453567078,
      handle: 'vortex-high-velocity-milk-pitcher',
      product: 'Vortex',
      option: 'With Handle',
      sku: 'Vortex001',
      available: true,
      image: 'https://cdn.shopify.com/s/files/1/1347/3541/files/New_Vortex_Hero_Photo.png?v=1775749897'
    },
    {
      productId: 7953769431142,
      variantId: 45391169683558,
      handle: 'vortex-milk-pitcher-no-handle-500ml',
      product: 'Vortex',
      option: 'No Handle',
      sku: 'Vortex001-NH',
      available: true,
      image: 'https://cdn.shopify.com/s/files/1/1347/3541/files/Vortex_No_Handle_Product_Photo_c474cb35-7535-48b6-83e3-f4335970dd6a.png?v=1775749844'
    },
    {
      productId: 1563927871590,
      variantId: 15468111200358,
      handle: 'ultra-sharp-2-0-classic-gold',
      product: 'Ultra Sharp 2.0',
      option: 'Mirror Multicolor / 20oz',
      sku: 'IK016',
      available: true,
      image: 'https://cdn.shopify.com/s/files/1/1347/3541/files/US2_Multicolor.png?v=1776194029'
    }
  ];
  var ELIGIBLE_IDS = ELIGIBLE.map(function (item) { return item.variantId; });
  // BOGOALL currently treats EVO and Vortex as qualifying "buy" products.
  // Ultra Sharp is eligible only as a discounted "get" product.
  var QUALIFYING_FIRST_IDS = [45535715033190, 42373983174758, 44451453567078, 45391169683558];
  var SECOND_OPTION_IDS = [45535715033190, 42373983174758, 44451453567078, 45391169683558, 15468111200358];
  var SECOND_OPTIONS = ELIGIBLE.filter(function (item) { return SECOND_OPTION_IDS.indexOf(item.variantId) !== -1; });
  var availabilityCheckedAt = 0;
  var mutationPending = false;
  var managedAddPending = false;
  var managedKitReconcilePending = false;
  var starterKitReconcilePromise = null;
  var lastRemovedItem = null;
  var undoTimer = null;
  var lastRenderedState = 'EMPTY';
  var lastDrawerOpenStartedAt = 0;
  var bundleWhatsappObserver = null;
  var bundleWhatsappMedia = null;
  var bundleWhatsappHero = null;
  var EUROPEAN_UNION = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE'];
  var path = location.pathname.replace(/\/$/, '') || '/';
  var isPurchasePath = Object.keys(ROUTES).some(function (key) { return path === ROUTES[key]; });

  document.documentElement.classList.add('bs-white-cart-enabled');
  if (isPurchasePath) document.documentElement.classList.add('bs-stage-core-path');
  window.__bsStageEvents = window.__bsStageEvents || new Set();

  function marketCode() {
    return String((window.Shopify && window.Shopify.country) || document.documentElement.getAttribute('data-country') || '').toUpperCase();
  }

  function isEuropeanUnion() {
    return EUROPEAN_UNION.indexOf(marketCode()) !== -1;
  }

  function syncEuVatNotice(container, beforeNode) {
    if (!container || !beforeNode) return;
    var notice = container.querySelector('[data-bs-eu-vat-notice]');
    if (!isEuropeanUnion()) {
      if (notice) notice.remove();
      return;
    }
    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'bs-eu-vat-notice';
      notice.setAttribute('data-bs-eu-vat-notice', '');
      notice.innerHTML = 'EU orders over €150: VAT is normally charged by customs or the carrier before or upon delivery, not at checkout. <a href="/pages/featured-content">See Shipping Policy.</a>';
      container.insertBefore(notice, beforeNode);
    }
  }

  function deviceCategory() {
    if (matchMedia('(max-width: 599px)').matches) return 'mobile';
    if (matchMedia('(max-width: 1024px)').matches) return 'tablet';
    return 'desktop';
  }

  function currentProductHandle() {
    var match = path.match(/^\/products\/([^/]+)/);
    return match ? match[1] : '';
  }

  function emit(name, detail, dedupeKey) {
    detail = detail || {};
    var key = name + ':' + (dedupeKey || JSON.stringify(detail));
    if (window.__bsStageEvents.has(key)) return;
    window.__bsStageEvents.add(key);
    var params = new URLSearchParams(location.search);
    var payload = Object.assign({
      event: name,
      landing_page: path,
      product_handle: currentProductHandle(),
      page_version: VERSION,
      drawer_version: DRAWER_VERSION,
      offer_version: OFFER_VERSION,
      device_category: deviceCategory(),
      market_country: marketCode(),
      traffic_source: document.referrer ? new URL(document.referrer).hostname : 'direct',
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      starter_kit_state: PRESET_STARTER_KIT_ENABLED ? (CUSTOM_PAIR_STARTER_KIT_ENABLED ? 'preset-and-custom-enabled' : 'preset-enabled') : (CUSTOM_PAIR_STARTER_KIT_ENABLED ? 'custom-pair-enabled' : 'disabled')
    }, detail);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('bs:analytics', { detail: payload }));
    var debug = document.getElementById('bs-stage-analytics-debug');
    if (!debug) {
      debug = document.createElement('script');
      debug.id = 'bs-stage-analytics-debug';
      debug.type = 'application/json';
      debug.textContent = '[]';
      document.documentElement.appendChild(debug);
    }
    var debugEvents = JSON.parse(debug.textContent || '[]');
    debugEvents.push(payload);
    debug.textContent = JSON.stringify(debugEvents.slice(-50));
  }

  function money(cents, currency) {
    currency = currency || 'USD';
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: Number(cents || 0) % 100 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format((cents || 0) / 100);
    } catch (error) {
      return '$' + ((cents || 0) / 100).toFixed(Number(cents || 0) % 100 === 0 ? 0 : 2);
    }
  }

  function eligibleById(variantId) {
    return ELIGIBLE.find(function (item) { return item.variantId === Number(variantId); }) || null;
  }

  function pitcherName(item) {
    return item ? item.product + ' — ' + item.option : '';
  }

  function freePitcherAction(item) {
    if (!item) return 'Add free pitcher';
    if (/^Ultra Sharp/i.test(item.product)) return 'Add free Ultra Sharp';
    return 'Add free ' + item.product;
  }

  function secondOptionButtonHtml(item, badge) {
    return '<button class="bs-cart-option" type="button" data-bs-second="' + item.variantId + '" aria-pressed="false" ' + (item.available ? '' : 'disabled') + '>' +
      '<img src="' + escapeHtml(item.image) + '" alt=""><span><strong>' + escapeHtml(item.option.replace(' / 20oz', '')) + '</strong>' +
      (badge ? '<em class="bs-cart-option-badge">' + escapeHtml(badge) + '</em>' : '') +
      '<small>' + (item.available ? 'Available' : 'Sold out') + '</small></span></button>';
  }

  function secondPitcherOptionsHtml() {
    var evo = SECOND_OPTIONS.filter(function (item) { return item.productId === 7513953566822; });
    var vortex = SECOND_OPTIONS.filter(function (item) { return item.product === 'Vortex'; });
    var ultra = SECOND_OPTIONS.filter(function (item) { return /^Ultra Sharp/i.test(item.product); });
    function group(label, items, badges) {
      return '<div class="bs-cart-model-group"><p class="bs-cart-model-label">MODEL: ' + escapeHtml(label) + '</p><div class="bs-cart-options">' +
        items.map(function (item) { return secondOptionButtonHtml(item, badges && badges[item.variantId]); }).join('') + '</div></div>';
    }
    return '<div class="bs-cart-model-groups">' +
      group('EVO 2.0', evo) +
      group('Vortex', vortex, { 44451453567078: 'Most popular pairing' }) +
      group('Ultra Sharp 20 oz', ultra) +
      '</div>';
  }

  function refreshAvailability() {
    if (Date.now() - availabilityCheckedAt < 60000) return Promise.resolve();
    var handles = Array.from(new Set(ELIGIBLE.map(function (item) { return item.handle; })));
    return Promise.all(handles.map(function (handle) {
      return fetch('/products/' + handle + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) { if (!response.ok) throw new Error('Availability could not be verified.'); return response.json(); })
        .then(function (product) {
          (product.variants || []).forEach(function (variant) {
            var item = eligibleById(variant.id);
            if (item) {
              item.available = Boolean(variant.available);
              item.option = variant.title && variant.title !== 'Default Title' ? variant.title : item.option;
              item.image = variant.featured_image && (variant.featured_image.src || variant.featured_image.url) ||
                product.featured_image || item.image;
            }
          });
        });
    })).then(function () { availabilityCheckedAt = Date.now(); });
  }

  function injectStyles() {
    if (document.getElementById('bs-stage-core-style')) return;
    var style = document.createElement('style');
    style.id = 'bs-stage-core-style';
    style.textContent = [
      'body.bs-stage-commerce-active [id*="wheelio" i],body.bs-stage-commerce-active [class*="wheelio" i],body.bs-stage-commerce-active iframe[src*="wheelio" i],body.bs-stage-commerce-active [id*="rollie" i],body.bs-stage-commerce-active [class*="rollie" i]{display:none!important;visibility:hidden!important;pointer-events:none!important}',
      '.bs-white-cart-enabled .cart-container .cart_content{display:none!important;visibility:hidden!important;pointer-events:none!important}',
      'body.bs-stage-commerce-active a[href*="wa.me" i],body.bs-stage-commerce-active a[href*="whatsapp" i],body.bs-stage-commerce-active [class*="whatsapp" i],body.bs-stage-commerce-active [id*="whatsapp" i],body.bs-stage-commerce-active iframe[src*="whatsapp" i]{display:none!important;visibility:hidden!important;pointer-events:none!important}',
      '@media (max-width:420px){body.bs-stage-bundle-wa-suppressed a[href*="wa.me" i],body.bs-stage-bundle-wa-suppressed a[href*="whatsapp" i],body.bs-stage-bundle-wa-suppressed [class*="whatsapp" i],body.bs-stage-bundle-wa-suppressed [id*="whatsapp" i],body.bs-stage-bundle-wa-suppressed iframe[src*="whatsapp" i]{display:none!important;visibility:hidden!important;pointer-events:none!important}}',
      '#bs-cart-drawer-root{z-index:2147483000}',
      '#bs-cart-drawer-root [hidden]{display:none!important}',
      '[data-bs-context]:empty{display:none}',
      '.bs-eu-vat-notice{margin:0 0 10px;color:#4f4d48;font-size:12px;line-height:1.45;text-align:left}',
      '.bs-eu-vat-notice a{color:inherit;text-decoration:underline;text-underline-offset:2px}',
      '.bs-cart-context{margin:18px 0 0}',
      '.bs-cart-eyebrow{margin:0 0 7px;color:#9b593a;font-size:11px;font-weight:800;letter-spacing:.12em;text-transform:uppercase}',
      '.bs-cart-state-title{margin:0 0 7px;color:#151515;font-size:18px;line-height:1.25;font-weight:760}',
      '.bs-cart-state-copy{margin:0;color:#686761;font-size:13px;line-height:1.5}',
      '.bs-cart-notice,.bs-cart-error{margin:14px 0;padding:13px 14px;border:1px solid #dedbd3;border-radius:8px;background:#fff;color:#373631;font-size:13px;line-height:1.45}',
      '.bs-cart-error{border-color:#d9aaa0;background:#fff5f2;color:#762d21}',
      '.bs-cart-retry,.bs-cart-secondary,.bs-cart-pair-action{width:100%;min-height:46px;margin-top:12px;border-radius:6px;font-size:13px;font-weight:760;cursor:pointer}',
      '.bs-cart-retry,.bs-cart-pair-action{border:0;background:#151515;color:#fff}',
      '.bs-cart-secondary{border:1px solid #bbb8b0;background:#fff;color:#151515}',
      '.bs-cart-retry:disabled,.bs-cart-pair-action:disabled,.bs-cart-secondary:disabled{opacity:.55;cursor:wait}',
      '.bs-line-prices{display:flex;align-items:baseline;gap:7px;flex-wrap:wrap}',
      '.bs-cart-price-wrap{margin:0}',
      '.bs-line-compare{color:#8d8a83;text-decoration:line-through;font-size:12px}',
      '.bs-line-discount{display:block;margin-top:3px;color:#2f6b46;font-size:11px;font-weight:760}',
      '.bs-each-price{margin:8px 0 0;color:#686761;font-size:12px}',
      '.bs-included-heading{display:flex;justify-content:space-between;gap:12px;align-items:end;margin:22px 0 10px}',
      '.bs-included-heading h3{margin:0;color:#151515;font-size:12px;font-weight:800;letter-spacing:.1em;text-transform:uppercase}',
      '.bs-included-heading span{color:#686761;font-size:11px;text-align:right}',
      '.bs-cart-options{display:grid;grid-template-columns:1fr 1fr;gap:9px;margin:14px 0}',
      '.bs-cart-model-groups{display:grid;gap:15px;margin:16px 0 4px}',
      '.bs-cart-model-group{padding-top:13px;border-top:1px solid #dedbd3}',
      '.bs-cart-model-group:first-child{padding-top:0;border-top:0}',
      '.bs-cart-model-label{margin:0;color:#151515;font-size:11px;font-weight:800;letter-spacing:.1em}',
      '.bs-cart-model-group .bs-cart-options{margin:8px 0 0}',
      '.bs-cart-option{display:grid;grid-template-columns:54px 1fr;gap:9px;align-items:center;padding:9px;border:1px solid #dedbd3;border-radius:8px;background:#fff;color:#151515;text-align:left;cursor:pointer}',
      '.bs-cart-option[aria-pressed="true"]{border-color:#2f6b46;box-shadow:0 0 0 1px #2f6b46}',
      '.bs-cart-option:disabled{opacity:.45;cursor:not-allowed}',
      '.bs-cart-option img{width:54px;height:54px;border-radius:6px;object-fit:cover;background:#eeece6}',
      '.bs-cart-option strong,.bs-cart-option small{display:block}.bs-cart-option small{margin-top:3px;color:#686761;font-size:11px;line-height:1.25}',
      '.bs-cart-option-badge{display:inline-block;margin-top:5px;padding:3px 6px;border-radius:999px;background:#efe7dc;color:#74452f;font-size:9px;font-style:normal;font-weight:800;letter-spacing:.04em;text-transform:uppercase}',
      '.bs-cart-discount-summary{display:flex;justify-content:space-between;gap:15px;margin-top:12px;padding:12px 0;border-top:1px solid #dedbd3;color:#2f6b46;font-size:13px;font-weight:760}',
      '.bs-charge-regions{display:block!important;padding:11px 12px!important;border-top:1px solid #ebe8e2;background:#fbfaf7}',
      '.bs-charge-region-list{display:grid;gap:7px;color:#4e4c47;font-size:12px;font-weight:400;line-height:1.4}',
      '.bs-charge-region-row{display:grid;grid-template-columns:20px minmax(0,1fr);gap:7px;align-items:start}',
      '.bs-charge-region-row b{color:#151515;font-weight:760}',
      '.bs-cart-loading{padding:36px 0;text-align:center;color:#686761;font-size:14px}',
      '.bs-cart-page-contract{max-width:760px;margin:18px auto;padding:14px 16px;border:1px solid #dedbd3;border-radius:8px;background:#f8f6f1;color:#151515}',
      '.bs-cart-page-contract p{margin:4px 0;color:#686761;font-size:13px;line-height:1.45}',
      '.bs-cart-page-contract strong{color:#151515}',
      '.bs-money-back{color:#b06a45!important}',
      'body.bs-stage-selector-active main>*:not(#bs-stage-selector-copy){display:none!important}body.bs-stage-selector-active #bs-stage-selector-copy{max-width:900px;margin:40px auto;padding:24px}',
      '@media(min-width:600px) and (max-width:1024px){.bs-stage-core-path #gC3o87pZC6,.bs-stage-core-path body.product-gp-template-618278482840912593 #gCUdBDRw_S{grid-template-columns:minmax(0,1fr)!important;row-gap:24px!important}.bs-stage-core-path #gC3o87pZC6>*,.bs-stage-core-path body.product-gp-template-618278482840912593 #gCUdBDRw_S>*{grid-column:1/-1!important;width:100%!important;max-width:100%!important}.bs-stage-core-path #gC3o87pZC6>.gd2s-PwPjJ,.bs-stage-core-path body.product-gp-template-618278482840912593 #gCUdBDRw_S>.gPuDqXleM2,.bs-stage-core-path body.product-gp-template-618278482840912593 #gCUdBDRw_S>.gjalT1VoGG{max-width:680px!important;margin-left:auto!important;margin-right:auto!important}}',
      '@media(min-width:761px) and (max-width:900px){.bs-stage-core-path .bs-bundle-page .hero{grid-template-columns:minmax(0,1fr)!important;align-items:start!important;gap:28px!important;max-height:none!important;padding-inline:44px!important}.bs-stage-core-path .bs-bundle-page .hero-copy,.bs-stage-core-path .bs-bundle-page .hero-gallery{width:100%!important;max-width:680px!important;margin-left:auto!important;margin-right:auto!important}}',
      '@media(max-width:600px){.bs-cart-options{grid-template-columns:1fr}.bs-cart-option{grid-template-columns:58px 1fr}.bs-cart-option img{width:58px;height:58px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function initBundleMobileWhatsapp() {
    if (path !== ROUTES.bundle) return;

    if (!bundleWhatsappMedia) {
      bundleWhatsappMedia = matchMedia('(max-width: 420px)');
      var syncForViewport = function () {
        var heroIsAheadOrVisible = Boolean(bundleWhatsappHero && bundleWhatsappHero.getBoundingClientRect().bottom > 0);
        document.body.classList.toggle('bs-stage-bundle-wa-suppressed', bundleWhatsappMedia.matches && heroIsAheadOrVisible);
      };
      if (bundleWhatsappMedia.addEventListener) bundleWhatsappMedia.addEventListener('change', syncForViewport);
      else if (bundleWhatsappMedia.addListener) bundleWhatsappMedia.addListener(syncForViewport);
    }

    var hero = document.querySelector('.bs-bundle-page .hero');
    if (!hero) return;
    if (hero === bundleWhatsappHero) return;

    if (bundleWhatsappObserver && bundleWhatsappHero) bundleWhatsappObserver.unobserve(bundleWhatsappHero);
    bundleWhatsappHero = hero;

    if (!('IntersectionObserver' in window)) {
      document.body.classList.toggle('bs-stage-bundle-wa-suppressed', bundleWhatsappMedia.matches);
      return;
    }

    bundleWhatsappObserver = bundleWhatsappObserver || new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target !== bundleWhatsappHero) return;
        var heroIsAheadOrVisible = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
        document.body.classList.toggle('bs-stage-bundle-wa-suppressed', bundleWhatsappMedia.matches && heroIsAheadOrVisible);
      });
    }, { threshold: 0 });
    bundleWhatsappObserver.observe(bundleWhatsappHero);
    document.body.classList.toggle('bs-stage-bundle-wa-suppressed', bundleWhatsappMedia.matches && hero.getBoundingClientRect().bottom > 0);
  }

  function wheelioSuppressedState() {
    return path === ROUTES.cart || /^\/checkout(?:\/|$)/.test(path) || document.body.classList.contains('bs-stage-commerce-active') || document.body.classList.contains('bs-cart-open');
  }

  function suppressWheelio(root) {
    root = root || document;
    var nodes = root.querySelectorAll ? root.querySelectorAll('[id*="wheelio" i],[class*="wheelio" i],iframe[src*="wheelio" i],[id*="rollie" i],[class*="rollie" i]') : [];
    nodes.forEach(function (node) {
      node.setAttribute('aria-hidden', 'true');
      node.setAttribute('hidden', '');
      node.setAttribute('inert', '');
      if ('inert' in node) node.inert = true;
      node.querySelectorAll && node.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(function (control) {
        control.setAttribute('tabindex', '-1');
      });
    });
  }

  function suppressLegacyDrawer(root) {
    root = root || document;
    var selector = '.cart-container .cart_content,#CartDrawer,[id="cart-drawer"]:not(#bs-cart-drawer-root),cart-drawer:not(#bs-cart-drawer-root)';
    var nodes = [];
    if (root.matches && root.matches(selector)) nodes.push(root);
    if (root.querySelectorAll) nodes = nodes.concat(Array.from(root.querySelectorAll(selector)));
    nodes.forEach(function (node) {
      if (node.id === 'bs-cart-drawer-root' || node.closest && node.closest('#bs-cart-drawer-root')) return;
      node.setAttribute('aria-hidden', 'true');
      node.setAttribute('hidden', '');
      if ('inert' in node) node.inert = true;
      node.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(function (control) {
        control.setAttribute('tabindex', '-1');
      });
    });
  }

  function bindLegacyCartClassGuards() {
    document.querySelectorAll('.cart-container').forEach(function (container) {
      if (container.getAttribute('data-bs-class-guard') === 'true') return;
      container.setAttribute('data-bs-class-guard', 'true');
      new MutationObserver(function () {
        if (container.classList.contains('active_link')) {
          container.classList.remove('active_link');
          if (!document.querySelector('#bs-cart-drawer-root[aria-hidden="false"]')) document.body.classList.remove('blocked-scroll');
        }
      }).observe(container, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function regionalHtml() {
    return '<div class="bs-stage-region">' +
      '<div>Worldwide shipping included</div>' +
      '<div>🇺🇸 US: $119 final price, with shipping, taxes, customs and duties included</div>' +
      '<div>🇪🇺 EU: Shipping included; VAT calculated and added at checkout</div>' +
      '</div>';
  }

  function guaranteeHtml() {
    return '<details class="bs-stage-guarantee"><summary>Try your pitcher for 21 days.' +
      '<span class="bs-stage-condition">Contact us within 45 days · Free return shipping</span></summary>' +
      '<p><strong>Your 45-Day Guarantee, Explained</strong></p>' +
      '<p>Use your pitcher for at least 21 days. Contact us within 45 days of delivery. Eligible satisfaction returns ship back free for a full refund.</p>' +
      '<p>For a satisfaction return of the EVO + Vortex system, return the entire bundle, including both pitchers and all included accessories. Partial bundle satisfaction returns are not available.</p>' +
      '<p>Defective products do not need to wait 21 days. A defective individual pitcher can be replaced without requiring return of the entire bundle. A defective accessory can be replaced or refunded individually.</p>' +
      '<p>This guarantee is in addition to any statutory consumer rights that apply in your country.</p>' +
      '<p><a href="/pages/return-policy">Read the full guarantee and return policy →</a></p></details>';
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('Cart could not be loaded.');
      return response.json();
    });
  }

  function addCartItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'The cart could not be updated.'); });
      return response.json();
    });
  }

  function updateCartLines(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'The cart could not be updated.'); });
      return response.json();
    });
  }

  function starterKitProperties(source) {
    return {
      '_bs_kit_source': source,
      '_bs_offer_version': OFFER_VERSION
    };
  }

  function starterKitSource(line) {
    var properties = line && line.properties || {};
    return properties._bs_kit_source || '';
  }

  function kitLineIsNativeZero(line) {
    var discounts = line && (line.line_level_discount_allocations || []);
    return Boolean(line) && Number(line.variant_id) === STARTER_KIT_VARIANT_ID &&
      Number(line.price || 0) === 0 && Number(line.original_price || 0) === 0 &&
      Number(line.final_price || 0) === 0 && Number(line.line_price || 0) === 0 &&
      Number(line.final_line_price || 0) === 0 && discounts.length === 0;
  }

  function paidAddonKitQuantityLimit(line, cart) {
    var properties = line && line.properties || {};
    var parentVariant = Number(properties._bs_parent_variant || 0);
    return (cart && cart.items || []).reduce(function (total, candidate) {
      return Number(candidate.product_id) === VU_BUNDLE_PRODUCT_ID && Number(candidate.variant_id) === parentVariant && selectorSetup(candidate) === selectorSetup(line) ?
        total + Number(candidate.quantity || 0) : total;
    }, 0);
  }

  function paidAddonKitMetadataValid(line) {
    var properties = line && line.properties || {};
    var quantity = Number(line && line.quantity || 0);
    return Boolean(line) && Number(line.variant_id) === VU_PAID_KIT_VARIANT_ID &&
      starterKitSource(line) === VU_PAID_KIT_SOURCE &&
      Number(properties._bs_parent_product || 0) === VU_BUNDLE_PRODUCT_ID &&
      Number(properties._bs_offer_price || 0) === VU_PAID_KIT_PRICE &&
      Number(line.price || 0) === VU_PAID_KIT_PRICE &&
      Number(line.original_price || 0) === VU_PAID_KIT_PRICE &&
      quantity > 0;
  }

  function paidAddonKitLineIsValid(line, cart) {
    return paidAddonKitMetadataValid(line) && paidAddonKitQuantityLimit(line, cart) >= Number(line.quantity);
  }

  function hiddenSetProperties(firstItem, secondItem, sourcePage) {
    return {
      'First Pitcher': pitcherName(firstItem),
      'Second Pitcher': pitcherName(secondItem),
      'Starter Kit': STARTER_KIT_TEXT,
      '_first_variant_id': String(firstItem.variantId),
      '_second_variant_id': String(secondItem.variantId),
      '_first_sku': firstItem.sku,
      '_second_sku': secondItem.sku,
      '_offer_version': OFFER_VERSION,
      '_source_page': sourcePage || path
    };
  }

  function hiddenLineIsValid(line) {
    var properties = line && line.properties || {};
    return Boolean(line) && Number(line.variant_id) === HIDDEN_SET_VARIANT_ID && Number(line.quantity) === 1 &&
      Number(line.final_line_price) === HIDDEN_SET_PRICE && properties['First Pitcher'] && properties['Second Pitcher'] &&
      properties['Starter Kit'] === STARTER_KIT_TEXT && properties._offer_version === OFFER_VERSION;
  }

  function cartFacts(cart) {
    var presetLines = [];
    var eligibleLines = [];
    var eligibleCartLines = [];
    var hiddenLines = [];
    var starterKitLines = [];
    var starterKitCartLines = [];
    var presetKitCartLines = [];
    var customKitCartLines = [];
    var unownedKitCartLines = [];
    var otherLines = [];
    var unrelatedLines = [];
    var presetQuantity = 0;
    var presetTotal = 0;
    var starterKitCount = 0;
    var presetKitQuantity = 0;
    var customKitQuantity = 0;
    var nonKitTotal = 0;
    var selectorTotal = 0;
    var pairDiscountAmount = 0;
    var pairDiscountTitles = [];
    cart.items.forEach(function (line) {
      if (selectorSetup(line)) {
        selectorTotal += Number(line.final_line_price || 0);
        nonKitTotal += Number(line.final_line_price || 0);
        otherLines.push(line);
        return;
      }
      if (isPresetLine(line)) {
        presetLines.push(line);
        presetQuantity += Number(line.quantity || 0);
        presetTotal += Number(line.final_line_price || 0);
        nonKitTotal += Number(line.final_line_price || 0);
        return;
      }
      if (Number(line.product_id) === HIDDEN_SET_PRODUCT_ID || Number(line.variant_id) === HIDDEN_SET_VARIANT_ID) {
        for (var h = 0; h < Number(line.quantity || 1); h += 1) hiddenLines.push(line);
        nonKitTotal += Number(line.final_line_price || 0);
        return;
      }
      if (isStarterKitLine(line) || isVuPaidStarterKitLine(line)) {
        var kitQuantity = Number(line.quantity || 0);
        var source = starterKitSource(line);
        // A paid Starter Kit belongs to the Vortex + Ultra Sharp page only when
        // its private line properties, $15 catalog price, and parent bundle line
        // all agree. Valid paid add-ons remain ordinary cart lines; malformed or
        // orphaned Kit lines continue through the existing removal safeguards.
        if (source === VU_PAID_KIT_SOURCE && paidAddonKitLineIsValid(line, cart)) {
          nonKitTotal += Number(line.final_line_price || 0);
          otherLines.push(line);
          unrelatedLines.push(line);
          return;
        }
        starterKitCartLines.push(line);
        starterKitCount += kitQuantity;
        for (var k = 0; k < kitQuantity; k += 1) starterKitLines.push(line);
        if (source === PRESET_KIT_SOURCE || source === tcBundleEngine.source) {
          presetKitCartLines.push(line);
          presetKitQuantity += kitQuantity;
        } else if (source === CUSTOM_PAIR_KIT_SOURCE) {
          customKitCartLines.push(line);
          customKitQuantity += kitQuantity;
        } else unownedKitCartLines.push(line);
        // When the feature is off, the Kit remains an ordinary purchasable product.
        if (!CUSTOM_PAIR_STARTER_KIT_ENABLED) {
          otherLines.push(line);
          unrelatedLines.push(line);
        }
        return;
      }
      nonKitTotal += Number(line.final_line_price || 0);
      otherLines.push(line);
      if (ELIGIBLE_IDS.indexOf(Number(line.variant_id)) !== -1) {
        eligibleCartLines.push(line);
        for (var i = 0; i < Number(line.quantity || 1); i += 1) eligibleLines.push(line);
        (line.line_level_discount_allocations || []).forEach(function (allocation) {
          var title = allocation.discount_application && allocation.discount_application.title || '';
          if (/BOGOALL/i.test(title)) {
            pairDiscountAmount += Number(allocation.amount || 0);
            if (pairDiscountTitles.indexOf(title) === -1) pairDiscountTitles.push(title);
          }
        });
      } else unrelatedLines.push(line);
    });
    var preset = presetLines.length > 0;
    var starterKitLine = starterKitCartLines[0] || null;
    var customKitLine = customKitCartLines[0] || null;
    var starterKitFree = starterKitCartLines.length === 1 && customKitCartLines.length === 1 &&
      customKitQuantity === 1 && kitLineIsNativeZero(customKitLine);
    // Kit entitlement follows supported variant identity and quantity, not discounts.
    var presetIdentified = preset && presetLines.every(function (line) {
      return Number.isSafeInteger(line.quantity) && line.quantity > 0;
    });
    // A preset is authoritative only when Shopify returns exactly one managed,
    // natively free Starter Kit line for every paid preset quantity.
    var orderKits = tcBundleEngine.facts(cart).kits;
    var presetKitVerified = presetIdentified && orderKits.length === 1 &&
      Number(orderKits[0].quantity) === 1 && tcBundleEngine.known(orderKits[0]) && kitLineIsNativeZero(orderKits[0]);
    var exactPair = !preset && eligibleLines.length === 2 && unrelatedLines.length === 0 &&
      hiddenLines.length === 0 && starterKitCount === 0;
    var pairAtOfferTotal = exactPair && pairDiscountAmount > 0 && pairDiscountTitles.length > 0 && Number(cart.total_price) - selectorTotal === 11900;
    var completePair = !preset && eligibleLines.length === 2 && unrelatedLines.length === 0 &&
      hiddenLines.length === 0 && starterKitCartLines.length === 1 && customKitQuantity === 1;
    var starterKitVerified = completePair && starterKitFree && pairDiscountAmount > 0 &&
      pairDiscountTitles.length > 0 && Number(cart.total_price) - selectorTotal === 11900;
    return {
      preset: preset,
      presetLines: presetLines,
      presetQuantity: presetQuantity,
      presetTotal: presetTotal,
      presetIdentified: presetIdentified,
      presetKitVerified: presetKitVerified,
      onlyPreset: preset && otherLines.length === 0 && hiddenLines.length === 0 && presetKitVerified,
      mixedPreset: preset && (otherLines.length > 0 || hiddenLines.length > 0),
      eligibleLines: eligibleLines,
      eligibleCartLines: eligibleCartLines,
      eligibleCount: eligibleLines.length,
      otherLines: otherLines,
      unrelatedLines: unrelatedLines,
      exactPair: exactPair,
      pairAtOfferTotal: pairAtOfferTotal,
      pairDiscountAmount: pairDiscountAmount,
      pairDiscountTitles: pairDiscountTitles,
      pairDiscountApplied: pairDiscountAmount > 0 && pairDiscountTitles.length > 0,
      hiddenLines: hiddenLines,
      hiddenCount: hiddenLines.length,
      hiddenLine: hiddenLines[0] || null,
      hiddenValid: hiddenLines.length === 1 && hiddenLineIsValid(hiddenLines[0]),
      hiddenConflict: hiddenLines.length > 0 && (hiddenLines.length !== 1 || eligibleLines.length > 0 || !hiddenLineIsValid(hiddenLines[0])),
      mixedOffer: preset && hiddenLines.length > 0,
      starterKitLines: starterKitLines,
      starterKitCartLines: starterKitCartLines,
      starterKitCount: starterKitCount,
      starterKitLine: starterKitLine,
      presetKitCartLines: presetKitCartLines,
      presetKitQuantity: presetKitQuantity,
      customKitCartLines: customKitCartLines,
      customKitQuantity: customKitQuantity,
      unownedKitCartLines: unownedKitCartLines,
      nonKitTotal: nonKitTotal,
      starterKitFree: starterKitFree,
      starterKitVerified: starterKitVerified
    };
  }

  function isPresetLine(line) {
    return PRESET_VARIANTS.indexOf(Number(line.variant_id)) !== -1;
  }

  function isStarterKitLine(line) {
    return Number(line.product_id) === STARTER_KIT_PRODUCT_ID || Number(line.variant_id) === STARTER_KIT_VARIANT_ID;
  }

  function isVuPaidStarterKitLine(line) {
    return Number(line.product_id) === VU_PAID_KIT_PRODUCT_ID || Number(line.variant_id) === VU_PAID_KIT_VARIANT_ID;
  }

  function itemImage(line) {
    return line.image || line.featured_image && (line.featured_image.url || line.featured_image.src) || '';
  }

  function lineDiscountLabel(line) {
    var titles = (line.line_level_discount_allocations || []).map(function (allocation) {
      return allocation.discount_application && allocation.discount_application.title || '';
    }).filter(Boolean);
    return titles.length ? titles.join(' · ') : '';
  }

  function lineHtml(line, currency) {
    if (selectorSetup(line) && !selectorParent(line)) return '';
    var selectorGroup = selectorParent(line) && latestCart ? selectorGroupForLine(line, latestCart) : null;
    if (selectorGroup) {
      if (selectorGroup.parents[0].key !== line.key) return '';
      line = Object.assign({}, line, {
        product_title: selectorGroup.setup === SELECTOR_VORTEX_SETUP ? selectorCopy.pairTitle : selectorCopy.ultraTitle,
        quantity: Math.ceil(selectorGroup.quantity),
        original_line_price: selectorGroup.total,
        final_line_price: selectorGroup.total
      });
    }
    var preset = isPresetLine(line);
    var title = preset ? 'EVO 2.0 + Vortex' : (line.product_title || line.title || 'Item');
    var rawVariant = line.variant_title && line.variant_title !== 'Default Title' ? line.variant_title : '';
    var variant = preset ? 'EVO finish: ' + (rawVariant || 'Selected finish') : rawVariant;
    var image = itemImage(line);
    var key = String(line.key || line.variant_id || '');
    var quantity = Math.max(1, Number(line.quantity || 1));
    var paidKitLimit = paidAddonKitLineIsValid(line, latestCart) ? paidAddonKitQuantityLimit(line, latestCart) : 0;
    var original = Number(line.original_line_price == null ? line.final_line_price : line.original_line_price);
    var finalPrice = Number(line.final_line_price || 0);
    var discount = lineDiscountLabel(line);
    var priceMarkup = '<div class="bs-line-prices">' +
      (original > finalPrice ? '<span class="bs-line-compare">' + money(original, currency) + '</span>' : '') +
      '<strong class="bs-cart-price">' + money(finalPrice, currency) + '</strong></div>' +
      (discount ? '<span class="bs-line-discount">' + escapeHtml(discount) + ' applied</span>' : '');
    return '<article class="bs-cart-item" data-bs-key="' + escapeHtml(key) + '">' +
      (image ? '<img class="bs-cart-image" src="' + escapeHtml(image) + '" alt="">' : '<div class="bs-cart-image" aria-hidden="true"></div>') +
      '<div class="bs-cart-item-info"><h2 class="bs-cart-item-title">' + escapeHtml(title) + '</h2>' +
      (variant ? '<p class="bs-cart-variant">' + escapeHtml(variant) + '</p>' : '') +
      '<div class="bs-cart-price-wrap">' + priceMarkup + '</div>' +
      (paidKitLimit ? '<p class="bs-cart-variant">Limit: one Starter Kit per matching 3-pitcher set.</p>' : '') +
      '<div class="bs-cart-item-actions"><div class="bs-quantity" role="group" aria-label="Quantity for ' + escapeHtml(title) + '">' +
      '<button type="button" data-bs-quantity="' + (quantity - 1) + '" data-bs-key="' + escapeHtml(key) + '" aria-label="Decrease quantity"' + (quantity <= 1 ? ' disabled' : '') + '>−</button>' +
      '<output aria-live="polite" aria-label="Quantity ' + quantity + '">' + quantity + '</output>' +
      '<button type="button" data-bs-quantity="' + (quantity + 1) + '" data-bs-key="' + escapeHtml(key) + '" aria-label="Increase quantity"' + (paidKitLimit && quantity >= paidKitLimit ? ' disabled title="Add another matching 3-pitcher set to increase the Starter Kit quantity"' : '') + '>+</button></div>' +
      '<button class="bs-remove" type="button" data-bs-remove data-bs-key="' + escapeHtml(key) + '">Remove</button></div></div></article>';
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (character) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character];
    });
  }

  function ensureDrawer() {
    var root = document.getElementById('bs-cart-drawer-root');
    if (!root) return null;
    if (root.getAttribute('data-bs-engine-bound') === 'true') return root;
    root.setAttribute('data-bs-engine-bound', 'true');
    var legacyChargeDetail = root.querySelector('strong[data-bs-charge-detail]');
    if (legacyChargeDetail) {
      var chargeDetail = document.createElement('div');
      chargeDetail.setAttribute('data-bs-charge-detail', '');
      legacyChargeDetail.replaceWith(chargeDetail);
    }
    var chargePanel = root.querySelector('[data-bs-panel="charges"]');
    if (chargePanel) {
      chargePanel.removeAttribute('data-bs-panel');
      chargePanel.classList.add('bs-charge-regions');
    }
    root.addEventListener('click', function (event) {
      var close = event.target.closest('[data-bs-close]');
      if (close) { closeDrawer(); return; }
      var panelButton = event.target.closest('[data-bs-panel-button]');
      if (panelButton) {
        setPanel(panelButton.getAttribute('data-bs-panel-button'));
        return;
      }
      var upgrade = event.target.closest('[data-bs-upgrade-single]');
      if(upgrade){croUpgradeSingle(upgrade);return;}
      var quantityButton = event.target.closest('[data-bs-quantity]');
      if (quantityButton) {
        changeCartLine(quantityButton.getAttribute('data-bs-key'), Number(quantityButton.getAttribute('data-bs-quantity')));
        return;
      }
      var removeButton = event.target.closest('[data-bs-remove]');
      if (removeButton) {
        removeCartLine(removeButton.getAttribute('data-bs-key'));
        return;
      }
      if (event.target.closest('[data-bs-undo]')) { undoRemove(); return; }
      var checkoutButton = event.target.closest('[data-bs-checkout]');
      if (checkoutButton) {
        if (checkoutButton.getAttribute('data-bs-action') === 'add-second') addSelectedSecondPitcher();
        else if (checkoutButton.getAttribute('data-bs-action') === 'add-starter-kit') addStarterKit();
        else checkoutCart();
        return;
      }
      if (event.target.closest('[data-bs-retry]')) {
        var retryNodes = drawerNodes();
        if (retryNodes) retryNodes.heading.textContent = 'Cart refreshed';
        renderDrawer();
        return;
      }
      var option = event.target.closest('[data-bs-second]');
      if (option) { selectSecondPitcher(option); return; }
      if (event.target.closest('[data-bs-add-second]')) addSelectedSecondPitcher();
    });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDrawer();
      if (event.key !== 'Tab') return;
      var focusable = Array.from(root.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function (element) { return element.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    return root;
  }

  var lastTrigger = null;
  var latestCart = null;
  var selectedSecondVariant = 0;

  function drawerNodes() {
    var root = ensureDrawer();
    return root ? {
      root: root,
      drawer: root.querySelector('.bs-cart-drawer'),
      body: root.querySelector('[data-bs-body]'),
      items: root.querySelector('[data-bs-items]'),
      context: root.querySelector('[data-bs-context]'),
      rating: root.querySelector('[data-bs-rating]'),
      assurance: root.querySelector('[data-bs-assurance]'),
      summary: root.querySelector('[data-bs-summary]'),
      total: root.querySelector('[data-bs-total]'),
      totalLabel: root.querySelector('[data-bs-total-label]'),
      checkout: root.querySelector('[data-bs-checkout]'),
      heading: root.querySelector('[data-bs-heading]'),
      chargeShort: root.querySelector('[data-bs-charge-short]'),
      chargeDetail: root.querySelector('[data-bs-charge-detail]'),
      footerGuarantee: root.querySelector('[data-bs-footer-guarantee]'),
      trustDot: root.querySelector('.bs-trust-dot'),
      toast: root.querySelector('[data-bs-toast]')
    } : null;
  }

  function setPanel(name) {
    var nodes = drawerNodes();
    if (!nodes) return;
    nodes.root.querySelectorAll('[data-bs-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-bs-panel') !== name;
    });
    nodes.root.querySelectorAll('[data-bs-panel-button]').forEach(function (button) {
      var open = button.getAttribute('data-bs-panel-button') === name;
      button.setAttribute('aria-expanded', String(open));
      var chevron = button.querySelector('.bs-chevron');
      if (chevron) chevron.classList.toggle('is-open', open);
    });
  }

  function openDrawer(trigger, message) {
    lastTrigger = trigger || document.activeElement;
    var nodes = drawerNodes();
    if (!nodes) return Promise.reject(new Error('The cart drawer shell is unavailable.'));
    var alreadyOpen = nodes.root.getAttribute('aria-hidden') === 'false' && !nodes.root.hidden;
    var now = Date.now();
    // GemPages and custom product sections can both hand the same successful
    // add to this public API. Coalesce only the immediate duplicate handoff;
    // later cart changes still refresh the open drawer normally.
    if (alreadyOpen && now - lastDrawerOpenStartedAt < 400) return Promise.resolve(latestCart);
    lastDrawerOpenStartedAt = now;
    nodes.root.hidden = false;
    nodes.root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bs-stage-commerce-active');
    document.body.classList.add('bs-cart-open');
    suppressWheelio(document);
    suppressLegacyDrawer(document);
    document.body.style.overflow = 'hidden';
    sessionStorage.setItem('bs_white_drawer_open', '1');
    var postAdd = sessionStorage.getItem('bs_stage_post_add') === '1';
    if (postAdd) sessionStorage.removeItem('bs_stage_post_add');
    nodes.heading.textContent = message || (postAdd ? 'Added to cart' : (alreadyOpen ? 'Cart updated' : 'Your cart'));
    renderLoading(nodes);
    if (!alreadyOpen) {
      nodes.drawer.focus({ preventScroll: true });
      emit('bs_drawer_open', {}, 'open:' + Date.now());
    }
    return renderDrawer();
  }

  function closeDrawer() {
    var nodes = drawerNodes();
    if (!nodes) return;
    nodes.root.hidden = true;
    nodes.root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bs-stage-commerce-active');
    document.body.classList.remove('bs-cart-open');
    document.body.classList.remove('blocked-scroll');
    document.querySelectorAll('.cart-container.active_link').forEach(function (container) { container.classList.remove('active_link'); });
    document.body.style.overflow = '';
    sessionStorage.removeItem('bs_white_drawer_open');
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus({ preventScroll: true });
    if (path === ROUTES.cart) location.reload();
  }

  function renderLoading(nodes) {
    nodes.items.innerHTML = '';
    nodes.context.innerHTML = '<div class="bs-cart-loading" role="status">Loading your cart…</div>';
    nodes.rating.hidden = true;
    nodes.assurance.hidden = true;
    nodes.summary.hidden = true;
  }

  function updateCartCount(cart) {
    var selectors = ['[data-cart-count]', '.cart_count', '.cart-count', '.header-cart__count', '[data-cart-count-bubble]', '.bs-store-cart-count'];
    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        node.textContent = String(cart.item_count || 0);
        node.hidden = false;
      });
    });
    document.querySelectorAll('a.bs-store-cart[href="/cart"]').forEach(function (node) {
      var count = cart.item_count || 0;
      node.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items'));
    });
    document.dispatchEvent(new CustomEvent('bs:cart-updated', { detail: { cart: cart } }));
  }

  function hasIncludedTrioShipping(cart) {
    var items = cart && cart.items || [];
    if (!items.length || cart.currency !== 'USD' || !(Number(cart.total_price) >= 8000)) return false;
    var sets = 0;
    var kits = 0;
    var other = false;
    items.forEach(function (line) {
      var quantity = Number(line.quantity);
      if (!(quantity > 0)) { other = true; return; }
      if (Number(line.product_id) === VU_BUNDLE_PRODUCT_ID && SELECTOR_ULTRA_IDS.indexOf(Number(line.variant_id)) !== -1) sets += quantity;
      else if (Number(line.product_id) === VU_PAID_KIT_PRODUCT_ID && Number(line.variant_id) === VU_PAID_KIT_VARIANT_ID && paidAddonKitLineIsValid(line, cart)) kits += quantity;
      else other = true;
    });
    return sets > 0 && !other && kits <= sets;
  }

  function marketCopy(state,facts) {
    var system = facts && facts.presetQuantity > 0;
    var onlySystem = system && facts.onlyPreset;
    var country=marketCode();
    if (hasIncludedTrioShipping(latestCart)) {
      var trioDetail = 'Local taxes, duties or carrier charges may apply. Review taxes at checkout and destination import charges in our shipping policy.';
      if (country === 'US') trioDetail = 'U.S.: duties and taxes prepaid. No charges on delivery.';
      else if (isEuropeanUnion()) trioDetail = 'EU: VAT collected at checkout for IOSS-eligible consignments up to €150; above €150, import VAT is normally collected by customs or the carrier.';
      return {short:'Worldwide standard shipping included with your 3-pitcher set',detail:'<span>'+escapeHtml(trioDetail)+'</span> <a href="/pages/featured-content">Shipping details</a>'};
    }
    var heading=system?'Worldwide shipping included with your Complete System':'Shipping shown for your destination at checkout';
    var detail='';
    if(country==='US') detail=system?'U.S.: system taxes and duties included too.':'U.S.: standalone pitcher shipping $9.99; orders $80+ ship free.';
    else if(isEuropeanUnion()) detail='EU: VAT collected at checkout for IOSS-eligible consignments up to €150; above €150, import VAT is normally collected by customs or the carrier.';
    else if(country==='GB') detail=system?'Local tax and duty treatment is shown in our shipping policy.':'Standalone pitcher shipping to GB: $9.99. Local taxes and duties may apply.';
    else if(country==='AU') detail=system?'Local tax and duty treatment is shown in our shipping policy.':'Standalone pitcher shipping to Australia: $14.99; qualifying $80+ orders ship free.';
    else detail='Local taxes or duties may apply. Check your destination details at checkout.';
    if(system&&!onlySystem)detail+=' Other items remain subject to their applicable shipping rules.';
    // Never assign single-pitcher rates to unrelated merchandise.
    var singlePresent=latestCart&&(latestCart.items||[]).some(function(l){return CRO_SINGLE_IDS.indexOf(Number(l.variant_id))!==-1;});
    if(!system&&!singlePresent) return {short:'Shipping and applicable taxes calculated at checkout',detail:'See your destination’s shipping and tax details at checkout.'};
    return {short:heading,detail:'<span>'+escapeHtml(detail)+'</span> <a href="/pages/featured-content">Shipping details</a>'};
  }

  function legacyMarketCopy() {
    return {
      short: '🇺🇸 Duties & taxes prepaid · 🇪🇺 VAT added at checkout',
      detail: '<span class="bs-charge-region-row"><span aria-hidden="true">🇺🇸</span><span><b>US:</b> All duties and taxes prepaid. No charges on delivery.</span></span>' +
        '<span class="bs-charge-region-row"><span aria-hidden="true">🇪🇺</span><span><b>EU:</b> VAT calculated and added at checkout.</span></span>'
    };
  }

  function prepareShell(state, cart, facts) {
    var nodes = drawerNodes();
    var guaranteeApplies = state === 'P0' || state === 'E1' || state === 'PAIR' || state === 'E2' || state === 'E3' ||
      (state === 'E0' && (cart.items || []).some(function (item) {
        return [48946539331686, 48946539364454, 48946539397222, 48946539429990].indexOf(Number(item.variant_id)) !== -1 && Number(item.quantity) > 0;
      }));
    var commerceContent = cart.item_count > 0;
    var copy = marketCopy(state, facts);
    lastRenderedState = state;
    nodes.root.setAttribute('data-bs-state', state);
    nodes.body.setAttribute('data-bs-state', state);
    nodes.rating.hidden = !(state === 'P0' || state === 'E1' || state === 'PAIR' || state === 'E2' || state === 'E3');
    nodes.assurance.hidden = !commerceContent;
    nodes.root.querySelectorAll('[data-bs-guarantee-section]').forEach(function (element) { element.hidden = !guaranteeApplies; });
    nodes.root.querySelectorAll('[data-bs-charges-section]').forEach(function (element) {
      if (element.hasAttribute('data-bs-panel-button')) {
        element.hidden = true;
        return;
      }
      element.hidden = !commerceContent;
    });
    var deliveryDetail = nodes.root.querySelector('[data-bs-delivery-detail]');
    if (deliveryDetail) deliveryDetail.hidden = true;
    nodes.root.querySelectorAll('[data-bs-payment]').forEach(function (element) { element.hidden = !commerceContent; });
    nodes.footerGuarantee.hidden = !guaranteeApplies;
    nodes.trustDot.hidden = !guaranteeApplies;
    nodes.summary.hidden = !commerceContent;
    syncEuVatNotice(nodes.summary, nodes.checkout);
    nodes.total.textContent = money(cart.total_price, cart.currency);
    nodes.totalLabel.textContent = state === 'P0' && facts.onlyPreset && facts.presetQuantity === 1 ? 'Bundle total' : 'Cart total';
    nodes.checkout.disabled = false;
    nodes.checkout.removeAttribute('data-bs-action');
    nodes.checkout.textContent = 'Checkout — ' + money(cart.total_price, cart.currency);
    nodes.chargeShort.textContent = copy.short;
    nodes.chargeDetail.innerHTML = copy.detail;
    setPanel(null);
    croEnhanceShell(nodes,cart,facts);
    return nodes;
  }

  function presetContentsHtml(facts) {
    var finishCounts = {};
    facts.presetLines.forEach(function (line) {
      var finish = line.variant_title && line.variant_title !== 'Default Title' ? line.variant_title : 'Selected finish';
      finishCounts[finish] = (finishCounts[finish] || 0) + Number(line.quantity || 0);
    });
    var finishes = Object.keys(finishCounts).map(function (finish) {
      return facts.presetQuantity > 1 ? finish + ' × ' + finishCounts[finish] : finish;
    }).join(' · ');
    var quantitySuffix = facts.presetQuantity > 1 ? ' × ' + facts.presetQuantity : '';
    return '<h3 class="bs-section-title">Everything included</h3>' +
      (facts.presetQuantity > 1 || facts.mixedPreset ? '<p class="bs-each-price">Each complete set: $119</p>' : '') +
      '<div class="bs-included-card" aria-label="Contents of the complete latte art set">' +
      '<div class="bs-included-row"><span class="bs-item-check" aria-hidden="true">✓</span><span class="bs-included-copy"><strong>EVO 2.0 pitcher' + quantitySuffix + '</strong><small>' + escapeHtml(finishes) + '</small></span></div>' +
      '<div class="bs-included-row"><span class="bs-item-check" aria-hidden="true">✓</span><span class="bs-included-copy"><strong>Vortex pitcher' + quantitySuffix + '</strong><small>500 ml each</small></span></div>' +
      '<div class="bs-included-row"><span class="bs-item-check" aria-hidden="true">✓</span><span class="bs-included-copy"><strong>Latte Art Starter Kit</strong><small>One per qualifying order: towel, puck screen + etching pen</small></span><span class="bs-free-pill">FREE</span></div></div>';
  }

  function stateForCart(cart) {
    var facts = cartFacts(cart);
    if (!cart.item_count) return 'EMPTY';
    if (CUSTOM_PAIR_STARTER_KIT_ENABLED && (facts.mixedOffer || facts.hiddenConflict)) return 'ERR';
    if(tcBundleEngine.facts(cart).count>0){try{tcBundleEngine.verify(cart);return 'TC';}catch(error){return 'ERR';}}
    if (facts.preset) return facts.presetKitVerified ? 'P0' : 'ERR';
    if (CUSTOM_PAIR_STARTER_KIT_ENABLED && facts.starterKitVerified) return 'E3';
    if (CUSTOM_PAIR_STARTER_KIT_ENABLED && facts.pairAtOfferTotal) return 'E2';
    if (PITCHER_GUIDANCE_ENABLED && facts.eligibleCount === 1 && facts.unrelatedLines.length === 0 &&
      facts.starterKitCount === 0 && QUALIFYING_FIRST_IDS.indexOf(Number(facts.eligibleLines[0].variant_id)) !== -1) return 'E1';
    if (PITCHER_GUIDANCE_ENABLED && facts.eligibleCount === 2) return 'PAIR';
    return 'E0';
  }

  function renderDrawer() {
    var nodes = drawerNodes();
    if (!nodes) return Promise.reject(new Error('The cart drawer shell is unavailable.'));
    return Promise.all([getCart(), refreshAvailability()]).then(function (results) {
      return reconcileStarterKitAuthority(results[0]);
    }).then(function (cart) {
      latestCart = cart;
      updateCartCount(cart);
      var facts = cartFacts(cart);
      var state = stateForCart(cart);
      if (state === 'EMPTY' || state === 'E0') return renderNormal(nodes.body, cart, facts);
      if(state==='TC'){renderNormal(nodes.body,cart,facts);var tc=tcBundleEngine.facts(cart);var tcNodes=drawerNodes();tcNodes.context.textContent="Build your own bundle"+' · '+tc.count+' · '+money(tc.actualTotal,cart.currency)+(tc.eligible?' · '+"One free starter kit per qualifying order.":'');return;}
      if (state === 'P0') return renderPreset(nodes.body, cart, facts);
      if (state === 'ERR') return renderOfferConflict(nodes.body, cart, facts);
      if (state === 'E2') return renderStarterKitReady(nodes.body, cart, facts);
      if (state === 'E3') return renderCompletePair(nodes.body, cart, facts);
      if (state === 'E1') return renderOne(nodes.body, cart, facts);
      if (state === 'PAIR') return renderPair(nodes.body, cart, facts);
      return renderNormal(nodes.body, cart, facts);
    }).catch(function (error) {
      emit('bs_cart_state_error', { drawer_state: 'ERR', error_code: 'cart_fetch' }, 'fetch');
      return getCart().then(function (cart) {
        latestCart = cart;
        updateCartCount(cart);
        renderRecoverableError(error, cart);
        return cart;
      }).catch(function () { renderRecoverableError(error); });
    });
  }

  function renderRecoverableError(error, refreshedCart) {
    var cart = refreshedCart || latestCart || { items: [], item_count: 0, total_price: 0, currency: 'USD' };
    var facts = cartFacts(cart);
    var nodes = prepareShell('ERR', cart, facts);
    nodes.heading.textContent = 'Cart needs a refresh';
    nodes.items.innerHTML = (cart.items || []).map(function (line) { return lineHtml(line, cart.currency); }).join('');
    nodes.context.innerHTML = '<div class="bs-cart-error" role="alert"><strong>We could not finish that cart update.</strong><br>' + escapeHtml(error.message || 'Please try again.') + '</div><button class="bs-cart-retry" type="button" data-bs-retry>Refresh cart</button>';
    nodes.rating.hidden = true;
    nodes.assurance.hidden = !cart.item_count;
  }

  function renderOfferConflict(body, cart, facts) {
    emit('bs_cart_state_error', { drawer_state: 'ERR', error_code: 'duplicate_complete_sets' }, 'duplicate-sets:' + cart.token + ':' + cart.item_count);
    var nodes = prepareShell('ERR', cart, facts);
    nodes.items.innerHTML = cart.items.map(function (line) { return lineHtml(line, cart.currency); }).join('');
    nodes.context.innerHTML = '<div class="bs-cart-error"><strong>Choose one complete-set offer.</strong><br>The preset set and a custom set cannot be checked out together.</div>';
  }

  function renderPreset(body, cart, facts) {
    var nodes = prepareShell('P0', cart, facts);
    // The real managed Kit line is verified in Shopify but represented inside the
    // approved compact inclusion card to avoid duplicating it visually.
    nodes.items.innerHTML = cart.items.filter(function (line) { return !isStarterKitLine(line); }).map(function (line) { return lineHtml(line, cart.currency); }).join('') + presetContentsHtml(facts);
    if (facts.mixedPreset) {
      nodes.context.innerHTML = '<div class="bs-cart-notice"><strong>Bundle price: $119 each.</strong><br>The cart total also includes the other products shown above.</div>';
    } else if (facts.presetQuantity > 1) {
      nodes.context.innerHTML = '<div class="bs-cart-notice"><strong>' + facts.presetQuantity + ' complete sets</strong><br>Each complete set: $119 · Actual cart total: ' + money(cart.total_price, cart.currency) + '</div>';
    } else nodes.context.innerHTML = '';
    emit('bs_cart_state_view', { drawer_state: 'P0', preset_quantity: facts.presetQuantity, cart_total: cart.total_price }, 'state:P0:' + cart.token + ':' + cart.item_count + ':' + cart.total_price);
  }

  function renderNormal(body, cart, facts) {
    var state = cart.item_count ? 'E0' : 'EMPTY';
    var nodes = prepareShell(state, cart, facts);
    nodes.rating.hidden = true;
    if (cart.item_count) {
      nodes.items.innerHTML = cart.items.map(function (line) { return lineHtml(line, cart.currency); }).join('');
      nodes.context.innerHTML = croUpgradeHtml(cart);
      emit('bs_cart_state_view', { drawer_state: 'E0', cart_total: cart.total_price }, 'state:E0:' + cart.token + ':' + cart.item_count + ':' + cart.total_price);
    } else {
      nodes.items.innerHTML = '';
      nodes.context.innerHTML = '<div class="bs-cart-empty"><div class="bs-empty-mark" aria-hidden="true">✓</div><h2>Your cart is empty</h2><p>Add a product when you are ready.</p><button type="button" data-bs-close>Continue shopping</button></div>';
      nodes.assurance.hidden = true;
      nodes.summary.hidden = true;
    }
  }

  function renderOne(body, cart, facts) {
    var nodes = prepareShell('E1', cart, facts);
    selectedSecondVariant = 0;
    emit('bs_second_pitcher_prompt_view', { drawer_state: 'E1', first_pitcher_variant: Number(facts.eligibleLines[0].variant_id) }, 'E1:' + cart.token);
    nodes.items.innerHTML = cart.items.map(function (line) { return lineHtml(line, cart.currency); }).join('');
    nodes.context.innerHTML = '<div class="bs-cart-context"><p class="bs-cart-eyebrow">PITCHER PAIR OFFER</p>' +
      '<h3 class="bs-cart-state-title">Your second pitcher is FREE</h3>' +
      '<p class="bs-cart-state-copy">Choose any eligible pitcher below. Your total will stay $119.</p>' +
      '<p class="bs-cart-state-copy">No code needed. Your free pitcher is applied automatically.</p>' +
      secondPitcherOptionsHtml() + '</div>';
    nodes.checkout.setAttribute('data-bs-action', 'add-second');
    nodes.checkout.disabled = true;
    nodes.checkout.textContent = 'Select a second pitcher';
  }

  function selectSecondPitcher(button) {
    selectedSecondVariant = Number(button.getAttribute('data-bs-second'));
    var nodes = drawerNodes();
    nodes.context.querySelectorAll('[data-bs-second]').forEach(function (candidate) {
      candidate.setAttribute('aria-pressed', String(candidate === button));
    });
    var item = SECOND_OPTIONS.find(function (candidate) { return candidate.variantId === selectedSecondVariant; });
    var action = nodes.checkout;
    if (!item || !item.available) return;
    action.disabled = false;
    action.textContent = 'ADD MY FREE PITCHER';
    emit('bs_second_pitcher_selected', { drawer_state: 'E1', second_pitcher_variant: selectedSecondVariant }, 'select:' + selectedSecondVariant);
  }

  function addSelectedSecondPitcher() {
    if (!selectedSecondVariant || mutationPending) return;
    var nodes = drawerNodes();
    var button = nodes.checkout;
    var item = eligibleById(selectedSecondVariant);
    mutationPending = true;
    button.disabled = true;
    button.textContent = 'Adding pitcher…';
    refreshAvailability().then(function () {
      if (!item || !item.available) throw new Error('That pitcher is no longer available. Choose another option.');
      return addCartItems([{ id: selectedSecondVariant, quantity: 1 }]);
    }).then(getCart).then(function (cart) {
      var facts = cartFacts(cart);
      if (facts.eligibleCount < 2) throw new Error('Shopify did not return the expected two-pitcher cart.');
      nodes.heading.textContent = 'Cart updated';
      emit('bs_second_pitcher_added', { drawer_state: 'PAIR', second_pitcher_variant: selectedSecondVariant, cart_total: cart.total_price }, 'second-add:' + cart.token + ':' + selectedSecondVariant + ':' + cart.item_count);
      return renderDrawer();
    }).catch(function (error) {
      return getCart().then(function (cart) { latestCart = cart; renderRecoverableError(error, cart); }).catch(function () { renderRecoverableError(error); });
    }).finally(function () { mutationPending = false; });
  }

  function renderPair(body, cart, facts) {
    var nodes = prepareShell('PAIR', cart, facts);
    nodes.items.innerHTML = cart.items.map(function (line) { return lineHtml(line, cart.currency); }).join('');
    nodes.context.innerHTML = '<div class="bs-cart-context"><p class="bs-cart-eyebrow">PITCHER PAIR</p><h3 class="bs-cart-state-title">Your two pitchers are in the cart</h3>' +
      (facts.pairDiscountApplied ?
        '<p class="bs-cart-state-copy">Your <strong>' + escapeHtml(facts.pairDiscountTitles.join(' · ')) + '</strong> discount is applied to the lines above.</p><div class="bs-cart-discount-summary"><span>Pair savings</span><span>' + money(facts.pairDiscountAmount, cart.currency) + '</span></div>' :
        '<div class="bs-cart-notice">The offer discount is not present yet. The cart total below is current; refresh before checkout to check again.</div>') +
      '</div>';
    emit('bs_cart_state_view', { drawer_state: 'PAIR', cart_total: cart.total_price, pair_discount: facts.pairDiscountAmount }, 'state:PAIR:' + cart.token + ':' + cart.item_count + ':' + cart.total_price);
  }

  function starterKitReconcilePlan(cart) {
    var facts = cartFacts(cart);
    var updates = {};
    if (facts.preset) {
      if (!PRESET_STARTER_KIT_ENABLED) return { action: 'error', facts: facts, updates: updates, message: 'Preset Starter Kit fulfillment is disabled.' };
      if (!facts.presetIdentified) {
        facts.starterKitCartLines.forEach(function (line) { updates[line.key] = 0; });
        return { action: 'error', facts: facts, updates: updates, message: 'Shopify did not verify the preset bundle quantity.' };
      }
      if (facts.presetKitVerified) return { action: 'none', facts: facts, updates: updates };
      if (facts.starterKitCartLines.length === 1 && facts.presetKitCartLines.length === 1 &&
          kitLineIsNativeZero(facts.presetKitCartLines[0])) {
        updates[facts.presetKitCartLines[0].key] = 1;
        return { action: 'update-preset', facts: facts, updates: updates, addQuantity: 0 };
      }
      facts.starterKitCartLines.forEach(function (line) { updates[line.key] = 0; });
      return {
        action: facts.starterKitCartLines.length ? 'replace-preset' : 'add-preset',
        facts: facts,
        updates: updates,
        addQuantity: 1
      };
    }
    if (CUSTOM_PAIR_STARTER_KIT_ENABLED && facts.starterKitVerified) return { action: 'none', facts: facts, updates: updates };
    // If a preset temporarily owned the one real Kit while a valid custom pair
    // coexisted, removing the preset must return that Kit to custom-pair
    // ownership instead of silently stripping fulfillment from the pair.
    var transferablePresetKit = CUSTOM_PAIR_STARTER_KIT_ENABLED &&
      facts.eligibleLines.length === 2 && facts.unrelatedLines.length === 0 &&
      facts.hiddenLines.length === 0 && facts.starterKitCartLines.length === 1 &&
      facts.presetKitCartLines.length === 1 && facts.customKitCartLines.length === 0 &&
      facts.unownedKitCartLines.length === 0 && facts.presetKitQuantity === 1 &&
      facts.pairDiscountAmount > 0 && facts.pairDiscountTitles.length > 0 &&
      Number(cart.total_price) === 11900 && kitLineIsNativeZero(facts.presetKitCartLines[0]);
    if (transferablePresetKit) {
      updates[facts.presetKitCartLines[0].key] = 0;
      return { action: 'transfer-custom', facts: facts, updates: updates, addQuantity: 1 };
    }
    if (!facts.starterKitCount) return { action: 'none', facts: facts, updates: updates };
    facts.starterKitCartLines.forEach(function (line) { updates[line.key] = 0; });
    return { action: 'remove', facts: facts, updates: updates };
  }

  function verifyPresetStarterKit(cart) {
    var facts = cartFacts(cart);
    if (!facts.presetKitVerified) throw new Error('Shopify did not verify the real $0 Starter Kit quantity for every preset bundle.');
    return cart;
  }

  function removeInvalidStarterKits(cart, error) {
    var facts = cartFacts(cart);
    if (!facts.starterKitCount) throw error;
    var updates = {};
    facts.starterKitCartLines.forEach(function (line) { updates[line.key] = 0; });
    return updateCartLines(updates).then(getCart).then(function () { throw error; });
  }

  function performStarterKitReconciliation(cart) {
    var plan = starterKitReconcilePlan(cart);
    if (plan.action === 'none') return Promise.resolve(cart);
    if (plan.action === 'error') {
      var error = new Error(plan.message);
      if (!Object.keys(plan.updates).length) return Promise.reject(error);
      return updateCartLines(plan.updates).then(getCart).then(function () { throw error; });
    }
    if (plan.action === 'remove') {
      return updateCartLines(plan.updates).then(getCart).then(function (refreshed) {
        emit('bs_starter_kit_removed', {
          drawer_state: 'L1',
          reason: plan.facts.presetKitQuantity ? 'preset_removed' : (plan.facts.eligibleCount !== 2 ? 'eligibility_lost' : 'authority_failed'),
          cart_total: refreshed.total_price
        }, 'starter-kit-removed:' + refreshed.token + ':' + refreshed.item_count + ':' + refreshed.total_price);
        return refreshed;
      });
    }
    if (plan.action === 'transfer-custom') {
      return updateCartLines(plan.updates).then(getCart).then(function (withoutPresetKit) {
        if (!cartFacts(withoutPresetKit).pairAtOfferTotal) throw new Error('The remaining custom pair could not be verified before restoring its Starter Kit.');
        return addCartItems([{
          id: STARTER_KIT_VARIANT_ID,
          quantity: 1,
          properties: starterKitProperties(CUSTOM_PAIR_KIT_SOURCE)
        }]);
      }).then(getCart).then(function (verifiedCustomPair) {
        if (!cartFacts(verifiedCustomPair).starterKitVerified) throw new Error('The custom-pair Starter Kit could not be restored after removing the preset.');
        return verifiedCustomPair;
      }).catch(function (error) { return getCart().then(function (current) { return removeInvalidStarterKits(current, error); }); });
    }
    if (plan.action === 'update-preset') {
      return updateCartLines(plan.updates).then(getCart).then(verifyPresetStarterKit).then(function (verified) {
        emit('bs_preset_kit_reconciled', {
          drawer_state: 'P0',
          preset_quantity: cartFacts(verified).presetQuantity,
          kit_quantity: cartFacts(verified).presetKitQuantity,
          cart_total: verified.total_price
        }, 'preset-kit-update:' + verified.token + ':' + cartFacts(verified).presetQuantity + ':' + verified.total_price);
        return verified;
      }).catch(function (error) { return getCart().then(function (current) { return removeInvalidStarterKits(current, error); }); });
    }
    var removeExisting = Object.keys(plan.updates).length ? updateCartLines(plan.updates).then(getCart) : Promise.resolve(cart);
    return removeExisting.then(function () {
      return addCartItems([{
        id: STARTER_KIT_VARIANT_ID,
        quantity: plan.addQuantity,
        properties: starterKitProperties(PRESET_KIT_SOURCE)
      }]);
    }).then(getCart).then(verifyPresetStarterKit).then(function (verified) {
      var verifiedFacts = cartFacts(verified);
      emit('bs_preset_kit_reconciled', {
        drawer_state: 'P0',
        preset_quantity: verifiedFacts.presetQuantity,
        kit_quantity: verifiedFacts.presetKitQuantity,
        cart_total: verified.total_price
      }, 'preset-kit-add:' + verified.token + ':' + verifiedFacts.presetQuantity + ':' + verified.total_price);
      return verified;
    }).catch(function (error) { return getCart().then(function (current) { return removeInvalidStarterKits(current, error); }); });
  }

  function reconcileStarterKitAuthority(cart) {
    if (!PRESET_STARTER_KIT_ENABLED && !CUSTOM_PAIR_STARTER_KIT_ENABLED) return Promise.resolve(cart);
    if (starterKitReconcilePromise) return starterKitReconcilePromise;
    managedKitReconcilePending = true;
    starterKitReconcilePromise = Promise.resolve().then(function () {
      tcBundleEngine.verifyPrice(cart);
      return tcBundleEngine.reconcile(cart,{get:getCart,change:lineChangeRequest,add:addCartItems});
    }).then(reconcileSelectorKits).then(function(updated){return tcBundleEngine.facts(updated).eligible?tcBundleEngine.verify(updated):performStarterKitReconciliation(updated);}).finally(function () {
      managedKitReconcilePending = false;
      starterKitReconcilePromise = null;
    });
    return starterKitReconcilePromise;
  }

  function renderStarterKitReady(body, cart, facts) {
    var nodes = prepareShell('E2', cart, facts);
    nodes.items.innerHTML = cart.items.map(function (line) { return lineHtml(line, cart.currency); }).join('');
    nodes.context.innerHTML = '<div class="bs-cart-context"><p class="bs-cart-eyebrow">COMPLETE YOUR SET</p>' +
      '<h3 class="bs-cart-state-title">Your free Starter Kit is ready</h3>' +
      '<p class="bs-cart-state-copy">You’ve completed your two-pitcher set. Add your free 3-piece Starter Kit, including a barista towel, 58.5mm puck screen and latte art etching pen.</p></div>';
    nodes.checkout.setAttribute('data-bs-action', 'add-starter-kit');
    nodes.checkout.textContent = 'ADD MY FREE STARTER KIT';
    emit('bs_starter_kit_prompt_view', { drawer_state: 'E2', cart_total: cart.total_price }, 'state:E2:' + cart.token + ':' + cart.total_price);
  }

  function addStarterKit() {
    if (!CUSTOM_PAIR_STARTER_KIT_ENABLED || mutationPending) return;
    var nodes = drawerNodes();
    mutationPending = true;
    nodes.checkout.disabled = true;
    nodes.checkout.textContent = 'ADDING YOUR FREE STARTER KIT…';
    getCart().then(function (before) {
      var beforeFacts = cartFacts(before);
      if (!beforeFacts.pairAtOfferTotal || beforeFacts.starterKitCount) throw new Error('The $119 two-pitcher cart could not be verified.');
      return addCartItems([{
        id: STARTER_KIT_VARIANT_ID,
        quantity: 1,
        properties: starterKitProperties(CUSTOM_PAIR_KIT_SOURCE)
      }]);
    }).then(getCart).then(function (after) {
      var afterFacts = cartFacts(after);
      if (!afterFacts.starterKitVerified) {
        return reconcileStarterKitAuthority(after).then(function () {
          throw new Error('Shopify did not verify one $0 Starter Kit while preserving BOGOALL and the $119 total. The Kit was removed.');
        });
      }
      emit('bs_starter_kit_added', { drawer_state: 'E3', variant_id: STARTER_KIT_VARIANT_ID, cart_total: after.total_price }, 'starter-kit:' + after.token);
      return renderDrawer();
    }).catch(function (error) {
      return getCart().then(reconcileStarterKitAuthority).then(function (cart) {
        latestCart = cart;
        renderRecoverableError(error, cart);
      }).catch(function () { renderRecoverableError(error); });
    }).finally(function () {
      mutationPending = false;
      setMutationBusy(false);
    });
  }

  function renderCompletePair(body, cart, facts) {
    var nodes = prepareShell('E3', cart, facts);
    nodes.items.innerHTML = cart.items.map(function (line) { return lineHtml(line, cart.currency); }).join('');
    nodes.context.innerHTML = '<div class="bs-cart-context"><p class="bs-cart-eyebrow">COMPLETE LATTE ART SET</p>' +
      '<h3 class="bs-cart-state-title">Your Complete Latte Art Set is ready</h3>' +
      '<p class="bs-cart-state-copy">2 pitchers + FREE 3-piece Starter Kit</p></div>';
    nodes.totalLabel.textContent = 'Complete set total';
    nodes.total.textContent = '$119';
    nodes.checkout.textContent = 'CHECKOUT — $119';
    emit('bs_cart_state_view', { drawer_state: 'E3', cart_total: cart.total_price, starter_kit_variant: STARTER_KIT_VARIANT_ID }, 'state:E3:' + cart.token + ':' + cart.total_price);
  }

  function showMutationError(button, message) {
    var old = button.parentNode.querySelector('.bs-stage-error');
    if (old) old.remove();
    button.insertAdjacentHTML('beforebegin', '<div class="bs-stage-error">' + escapeHtml(message) + '</div>');
  }

  function removeHiddenLines(cart) {
    var updates = {};
    cart.items.forEach(function (line) {
      if (Number(line.variant_id) === HIDDEN_SET_VARIANT_ID) updates[line.key] = 0;
    });
    return Object.keys(updates).length ? updateCartLines(updates) : Promise.resolve(cart);
  }

  function convertSingleToHiddenSet(firstLine, secondVariantId, button) {
    if (mutationPending) return;
    mutationPending = true;
    button.disabled = true;
    button.textContent = 'BUILDING YOUR SET…';
    var firstItem = eligibleById(firstLine.variant_id);
    var secondItem = eligibleById(secondVariantId);
    var hiddenWasAdded = false;
    var hiddenKey = '';
    return refreshAvailability().then(function () {
      if (!firstItem || !secondItem) throw new Error('Those pitcher selections are not eligible for this set.');
      if (!firstItem.available || !secondItem.available) throw new Error('One of those pitchers is no longer available. Please choose another.');
      return getCart();
    }).then(function (before) {
      var beforeFacts = cartFacts(before);
      var currentFirst = before.items.find(function (line) { return line.key === firstLine.key && Number(line.variant_id) === Number(firstLine.variant_id); });
      if (!currentFirst || beforeFacts.eligibleCount !== 1 || beforeFacts.hiddenCount) throw new Error('Your cart changed. It has been reloaded before converting the set.');
      return addCartItems([{ id: HIDDEN_SET_VARIANT_ID, quantity: 1, properties: hiddenSetProperties(firstItem, secondItem, path) }]);
    }).then(function () {
      hiddenWasAdded = true;
      return getCart();
    }).then(function (afterAdd) {
      var addedFacts = cartFacts(afterAdd);
      if (addedFacts.hiddenCount !== 1 || !addedFacts.hiddenValid) throw new Error('The complete set could not be verified at $119.');
      hiddenKey = addedFacts.hiddenLine.key;
      var updates = {};
      updates[firstLine.key] = 0;
      return updateCartLines(updates);
    }).then(function () { return getCart(); }).then(function (finalCart) {
      var finalFacts = cartFacts(finalCart);
      if (!finalFacts.hiddenValid || finalFacts.hiddenCount !== 1 || finalFacts.eligibleCount !== 0 || finalCart.items.some(function (line) { return line.key === firstLine.key; })) {
        throw new Error('The final $119 cart state could not be verified.');
      }
      emit('bs_custom_set_conversion_success', {
        drawer_state: 'E3',
        first_variant_id: firstItem.variantId,
        second_variant_id: secondItem.variantId,
        first_sku: firstItem.sku,
        second_sku: secondItem.sku,
        preset_or_custom: 'custom_set'
      }, 'custom-set:' + finalCart.token + ':' + firstItem.variantId + ':' + secondItem.variantId);
      return renderDrawer();
    }).catch(function (error) {
      var cleanup = hiddenWasAdded ? getCart().then(function (cart) {
        var sourceStillPresent = cart.items.some(function (line) { return Number(line.variant_id) === firstItem.variantId && Number(line.product_id) !== HIDDEN_SET_PRODUCT_ID; });
        if (sourceStillPresent) return cart;
        return addCartItems([{ id: firstItem.variantId, quantity: 1 }]).then(getCart);
      }).then(removeHiddenLines).catch(function () { return null; }) : Promise.resolve();
      return cleanup.then(function () {
        emit('bs_custom_set_conversion_error', { drawer_state: 'ERR', second_variant_id: secondVariantId, error_code: 'conversion_failed' }, 'convert-error:' + Date.now());
        button.disabled = false;
        button.textContent = 'TRY AGAIN';
        showMutationError(button, error.message + ' Your original pitcher has been retained.');
      });
    }).finally(function () { mutationPending = false; });
  }

  function hiddenPropertiesHtml(line) {
    var properties = line.properties || {};
    return '<ul class="bs-stage-property-list">' +
      '<li><strong>First Pitcher</strong>' + escapeHtml(properties['First Pitcher']) + '</li>' +
      '<li><strong>Second Pitcher</strong>' + escapeHtml(properties['Second Pitcher']) + '</li>' +
      '<li><strong>FREE Starter Kit</strong>Barista Towel · 58.5mm Puck Screen · Latte Art Etching Pen</li></ul>';
  }

  function renderHiddenSet(body, cart, facts) {
    var valid = facts.hiddenValid && !facts.hiddenConflict;
    var otherItems = cart.items.filter(function (line) { return !facts.hiddenLine || line.key !== facts.hiddenLine.key; });
    body.dataset.state = valid ? 'E3' : 'ERR';
    if (!valid) emit('bs_cart_state_error', { drawer_state: 'ERR', error_code: 'hidden_set_conflict', cart_total: cart.total_price }, 'hidden-conflict:' + cart.token + ':' + cart.item_count);
    body.innerHTML = '<p class="bs-stage-eyebrow">COMPLETE $119 SET</p><h3 class="bs-stage-title">' + (valid ? 'Your Complete Latte Art Set Is Ready' : 'Your set needs attention') + '</h3>' +
      (facts.hiddenLine ? hiddenPropertiesHtml(facts.hiddenLine) : '') +
      '<div class="bs-stage-total"><span>Complete set</span><span>' + (facts.hiddenLine ? money(facts.hiddenLine.final_line_price) : money(0)) + '</span></div>' +
      (otherItems.length ? '<p class="bs-stage-copy"><strong>Other cart items</strong></p><ul class="bs-stage-items">' + otherItems.map(lineHtml).join('') + '</ul><div class="bs-stage-total"><span>Cart total</span><span>' + money(cart.total_price) + '</span></div>' : '') +
      (valid ? '<p class="bs-stage-copy">Two selected pitchers and the Latte Art Starter Kit are included. No discount or additional product line is required.</p>' : '<div class="bs-stage-error">Checkout is paused because the cart does not contain exactly one verified $119 custom set.</div>') +
      regionalHtml() + guaranteeHtml() +
      (valid ? '<button class="bs-stage-action" type="button" data-bs-checkout>CONTINUE TO CHECKOUT</button><button class="bs-stage-secondary" type="button" data-bs-restart-set>EDIT MY PITCHER CHOICES</button>' : '<button class="bs-stage-action" type="button" data-bs-retry>REFRESH CART</button>');
    if (valid) {
      bindCheckout(body, 'E3');
      if (otherItems.length) bindLineActions(body, cart);
      body.querySelector('[data-bs-restart-set]').addEventListener('click', function () { restartHiddenSet(facts.hiddenLine, this); });
    } else body.querySelector('[data-bs-retry]').addEventListener('click', renderDrawer);
  }

  function restartHiddenSet(hiddenLine, button) {
    if (mutationPending) return;
    mutationPending = true;
    button.disabled = true;
    button.textContent = 'RESTORING FIRST PITCHER…';
    var firstId = Number((hiddenLine.properties || {})._first_variant_id);
    var firstItem = eligibleById(firstId);
    var firstAdded = false;
    return refreshAvailability().then(function () {
      if (!firstItem || !firstItem.available) throw new Error('Your original first pitcher is not currently available. The completed set was left unchanged.');
      return addCartItems([{ id: firstId, quantity: 1 }]);
    }).then(function () { firstAdded = true; return getCart(); }).then(function (afterAdd) {
      if (!afterAdd.items.some(function (line) { return Number(line.variant_id) === firstId; })) throw new Error('Your first pitcher could not be restored.');
      var updates = {}; updates[hiddenLine.key] = 0;
      return updateCartLines(updates);
    }).then(function () { return getCart(); }).then(function (finalCart) {
      var finalFacts = cartFacts(finalCart);
      if (finalFacts.hiddenCount || finalFacts.eligibleCount !== 1) throw new Error('The edit state could not be verified.');
      emit('bs_pair_edit', { drawer_state: 'E1', first_variant_id: firstId }, 'pair-edit:' + finalCart.token + ':' + Date.now());
      return renderDrawer();
    }).catch(function (error) {
      var rollback = firstAdded ? getCart().then(function (cart) {
        var updates = {};
        cart.items.forEach(function (line) { if (Number(line.variant_id) === firstId && Number(line.product_id) !== HIDDEN_SET_PRODUCT_ID) updates[line.key] = 0; });
        return Object.keys(updates).length ? updateCartLines(updates) : cart;
      }).catch(function () { return null; }) : Promise.resolve();
      return rollback.then(function () { button.disabled = false; button.textContent = 'REMOVE SET AND START AGAIN'; showMutationError(button, error.message); });
    }).finally(function () { mutationPending = false; });
  }

  function renderLegacyPair(body, cart, facts) {
    var convertible = facts.eligibleCount === 2;
    body.dataset.state = convertible ? 'LEGACY' : 'ERR';
    body.innerHTML = '<p class="bs-stage-eyebrow">LEGACY TWO-PITCHER CART</p><h3 class="bs-stage-title">' + (convertible ? 'Complete your offer and add the FREE Starter Kit.' : 'Please reduce the cart to two eligible pitchers.') + '</h3>' +
      '<ul class="bs-stage-items">' + cart.items.map(lineHtml).join('') + '</ul>' +
      (convertible ? '<p class="bs-stage-copy">Convert these exact two pitchers into one complete $119 set. Unrelated items will stay in your cart.</p><button class="bs-stage-action" type="button" data-bs-convert-legacy>CONVERT TO COMPLETE $119 SET</button>' : '<div class="bs-stage-error">Automatic conversion is paused because more than two eligible pitcher units are present.</div>') +
      regionalHtml() + guaranteeHtml();
    bindLineActions(body, cart);
    if (convertible) body.querySelector('[data-bs-convert-legacy]').addEventListener('click', function () { convertLegacyPair(facts.eligibleLines, this); });
  }

  function convertLegacyPair(lines, button) {
    if (mutationPending) return;
    mutationPending = true;
    button.disabled = true;
    button.textContent = 'CONVERTING…';
    var firstItem = eligibleById(lines[0].variant_id);
    var secondItem = eligibleById(lines[1].variant_id);
    var hiddenWasAdded = false;
    return refreshAvailability().then(function () {
      if (!firstItem || !secondItem || !firstItem.available || !secondItem.available) throw new Error('One of these pitchers is no longer available.');
      return addCartItems([{ id: HIDDEN_SET_VARIANT_ID, quantity: 1, properties: hiddenSetProperties(firstItem, secondItem, path) }]);
    }).then(function () { hiddenWasAdded = true; return getCart(); }).then(function (afterAdd) {
      var addedFacts = cartFacts(afterAdd);
      if (!addedFacts.hiddenValid || addedFacts.hiddenCount !== 1) throw new Error('The $119 complete set could not be verified.');
      var updates = {};
      lines.forEach(function (line) { updates[line.key] = 0; });
      return updateCartLines(updates);
    }).then(function () { return getCart(); }).then(function (finalCart) {
      var finalFacts = cartFacts(finalCart);
      if (!finalFacts.hiddenValid || finalFacts.hiddenConflict || finalFacts.eligibleCount) throw new Error('The converted cart could not be verified.');
      emit('bs_legacy_pair_conversion', { drawer_state: 'E3', first_variant_id: firstItem.variantId, second_variant_id: secondItem.variantId }, 'legacy:' + finalCart.token + ':' + Date.now());
      return renderDrawer();
    }).catch(function (error) {
      var cleanup = hiddenWasAdded ? getCart().then(function (cart) {
        var facts = cartFacts(cart);
        if (facts.eligibleCount >= 2) return cart;
        var required = {};
        required[firstItem.variantId] = (required[firstItem.variantId] || 0) + 1;
        required[secondItem.variantId] = (required[secondItem.variantId] || 0) + 1;
        facts.eligibleLines.forEach(function (line) { required[Number(line.variant_id)] = Math.max(0, (required[Number(line.variant_id)] || 0) - 1); });
        var restoreItems = Object.keys(required).filter(function (id) { return required[id] > 0; }).map(function (id) { return { id: Number(id), quantity: required[id] }; });
        return restoreItems.length ? addCartItems(restoreItems).then(getCart) : cart;
      }).then(removeHiddenLines).catch(function () { return null; }) : Promise.resolve();
      return cleanup.then(function () { button.disabled = false; button.textContent = 'TRY CONVERSION AGAIN'; showMutationError(button, error.message + ' Your original pitcher lines were retained.'); });
    }).finally(function () { mutationPending = false; });
  }

  function setMutationBusy(busy) {
    var nodes = drawerNodes();
    if (!nodes) return;
    if (busy) nodes.root.querySelectorAll('[data-bs-quantity],[data-bs-remove],[data-bs-add-second],[data-bs-undo]').forEach(function (control) {
      control.disabled = true;
    });
    nodes.checkout.disabled = Boolean(busy);
    if (!busy && lastRemovedItem) {
      var undo = nodes.toast.querySelector('[data-bs-undo]');
      if (undo) undo.disabled = false;
    }
  }

  function lineChangeRequest(key, quantity) {
    function request(payload) {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (response) {
        if (response.ok) return response.json();
        return response.json().catch(function () { return {}; }).then(function (data) {
          throw new Error(data.description || data.message || 'That cart item could not be updated.');
        });
      });
    }
    return request({ id: key, quantity: quantity }).catch(function (firstError) {
      return getCart().then(function (cart) {
        var index = cart.items.findIndex(function (line) { return String(line.key) === String(key); });
        if (index < 0) throw firstError;
        return request({ line: index + 1, quantity: quantity });
      });
    });
  }

  function changeCartLine(key, quantity) {
    if (!key || mutationPending || quantity < 0) return;
    var sourceLine = latestCart && latestCart.items.find(function (line) { return String(line.key) === String(key); });
    if (sourceLine && paidAddonKitLineIsValid(sourceLine, latestCart) && quantity > paidAddonKitQuantityLimit(sourceLine, latestCart)) return;
    mutationPending = true;
    setMutationBusy(true);
    var before = latestCart;
    var beforeFacts = before ? cartFacts(before) : null;
    var selectorGroup = sourceLine && selectorParent(sourceLine) ? selectorGroupForLine(sourceLine, before) : null;
    var change = selectorGroup ? selectorGroupChange(selectorGroup, quantity) : lineChangeRequest(key, quantity);
    change.then(getCart).then(function (cart) {
      latestCart = cart;
      var afterFacts = cartFacts(cart);
      if (beforeFacts && beforeFacts.eligibleCount >= 2 && afterFacts.eligibleCount < 2) {
        emit('bs_eligibility_lost', { drawer_state: 'L1', cart_total: cart.total_price }, 'lost:' + cart.token + ':' + cart.item_count + ':' + cart.total_price);
      }
      var nodes = drawerNodes();
      if (nodes) nodes.heading.textContent = 'Cart updated';
      return renderDrawer();
    }).catch(function (error) {
      emit('bs_cart_state_error', { drawer_state: 'ERR', error_code: 'quantity_failed' }, 'quantity:' + Date.now());
      return getCart().then(function (cart) {
        latestCart = cart;
        renderRecoverableError(error, cart);
      }).catch(function () { renderRecoverableError(error); });
    }).finally(function () {
      mutationPending = false;
      setMutationBusy(false);
    });
  }

  function showUndoToast() {
    var nodes = drawerNodes();
    if (!nodes || !lastRemovedItem) return;
    nodes.toast.hidden = false;
    var undo = nodes.toast.querySelector('[data-bs-undo]');
    if (undo) undo.disabled = false;
    var label = nodes.toast.querySelector('span');
    if (label) label.textContent = (lastRemovedItem.product_title || lastRemovedItem.title || 'Item') + ' removed';
    if (undoTimer) clearTimeout(undoTimer);
    undoTimer = setTimeout(function () {
      nodes.toast.hidden = true;
      lastRemovedItem = null;
      undoTimer = null;
    }, 12000);
  }

  function removeCartLine(key) {
    if (!key || mutationPending) return;
    var sourceCart = latestCart;
    var sourceLine = sourceCart && sourceCart.items.find(function (line) { return String(line.key) === String(key); });
    if (!sourceLine) {
      renderRecoverableError(new Error('That cart line changed. Refresh the cart and try again.'), sourceCart);
      return;
    }
    var selectorGroup = selectorParent(sourceLine) ? selectorGroupForLine(sourceLine, sourceCart) : null;
    lastRemovedItem = JSON.parse(JSON.stringify(sourceLine));
    if (selectorGroup) lastRemovedItem.quantity = selectorGroup.units;
    mutationPending = true;
    setMutationBusy(true);
    var beforeFacts = cartFacts(sourceCart);
    var removal = selectorGroup ? updateCartLines(selectorGroupUpdates(selectorGroup, 0)) : lineChangeRequest(key, 0);
    removal.then(getCart).then(function (cart) {
      latestCart = cart;
      var afterFacts = cartFacts(cart);
      if (beforeFacts.eligibleCount >= 2 && afterFacts.eligibleCount < 2) {
        emit('bs_eligibility_lost', { drawer_state: 'L1', cart_total: cart.total_price }, 'lost:' + cart.token + ':' + cart.item_count + ':' + cart.total_price);
      }
      var nodes = drawerNodes();
      if (nodes) nodes.heading.textContent = 'Item removed';
      return renderDrawer().then(showUndoToast);
    }).catch(function (error) {
      lastRemovedItem = null;
      emit('bs_cart_state_error', { drawer_state: 'ERR', error_code: 'remove_failed' }, 'remove:' + Date.now());
      return getCart().then(function (cart) {
        latestCart = cart;
        renderRecoverableError(error, cart);
      }).catch(function () { renderRecoverableError(error); });
    }).finally(function () {
      mutationPending = false;
      setMutationBusy(false);
    });
  }

  function undoRemove() {
    if (!lastRemovedItem || mutationPending) return;
    var item = lastRemovedItem;
    var restore = {
      id: Number(item.variant_id),
      quantity: Number(item.quantity || 1)
    };
    if (item.properties && Object.keys(item.properties).length) restore.properties = item.properties;
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) restore.selling_plan = item.selling_plan_allocation.selling_plan.id;
    mutationPending = true;
    setMutationBusy(true);
    addCartItems([restore]).then(getCart).then(function (cart) {
      latestCart = cart;
      lastRemovedItem = null;
      if (undoTimer) clearTimeout(undoTimer);
      var nodes = drawerNodes();
      if (nodes) {
        nodes.toast.hidden = true;
        nodes.heading.textContent = 'Item restored';
      }
      emit('bs_cart_remove_undo', { drawer_state: 'UNDO', variant_id: restore.id, quantity: restore.quantity }, 'undo:' + cart.token + ':' + restore.id + ':' + cart.item_count);
      return renderDrawer();
    }).catch(function (error) {
      return getCart().then(function (cart) {
        latestCart = cart;
        renderRecoverableError(error, cart);
      }).catch(function () { renderRecoverableError(error); });
    }).finally(function () {
      mutationPending = false;
      setMutationBusy(false);
    });
  }

  function presetCartPricesVerified(cart) {
    function amount(value) {
      return Number.isSafeInteger(value) && value >= 0 ? value : NaN;
    }
    // final_line_price already includes line discounts. Subtract only Shopify's
    // cart-level allocations here; total_discount would count line discounts twice.
    var lineTotal = cart.items.reduce(function (sum, line) {
      return sum + amount(line.final_line_price);
    }, 0);
    var cartDiscount = (cart.cart_level_discount_applications || []).reduce(function (sum, discount) {
      return sum + amount(discount.total_allocated_amount);
    }, 0);
    return amount(cart.total_price) === lineTotal - cartDiscount;
  }

  function verifyCheckoutAuthority(cart) {
    tcBundleEngine.verify(cart);
    verifySelectorKits(cart);
    if(tcBundleEngine.facts(cart).count||tcBundleEngine.facts(cart).eligible){tcBundleEngine.verify(cart);if(!cart.item_count||!presetCartPricesVerified(cart))throw new Error('The cart total could not be verified.');return cartFacts(cart);}
    if (selectorGroups(cart).length && !presetCartPricesVerified(cart)) throw new Error(selectorCopy.kitError);
    var facts = cartFacts(cart);
    if (!cart.item_count) throw new Error('Your cart is empty.');
    if (facts.preset && !facts.presetKitVerified) throw new Error('The preset Starter Kit quantity could not be verified. Please refresh the cart.');
    if (facts.preset && !presetCartPricesVerified(cart)) throw new Error('Shopify cart totals could not be verified. Please refresh the cart.');
    if (CUSTOM_PAIR_STARTER_KIT_ENABLED && facts.mixedOffer) throw new Error('Remove either the preset set or the custom set before checkout.');
    if (CUSTOM_PAIR_STARTER_KIT_ENABLED && facts.hiddenCount && (!facts.hiddenValid || facts.hiddenConflict)) throw new Error('The custom set is not verified. Please review the cart before checkout.');
    if (!facts.preset && CUSTOM_PAIR_STARTER_KIT_ENABLED && facts.starterKitCount && !facts.starterKitVerified) throw new Error('The Starter Kit is not verified as free. It must be removed before checkout.');
    return facts;
  }

  function checkoutCart() {
    if (mutationPending) return;
    var nodes = drawerNodes();
    mutationPending = true;
    nodes.checkout.disabled = true;
    nodes.checkout.textContent = 'Checking cart…';
    getCart().then(reconcileStarterKitAuthority).then(function (cart) {
      latestCart = cart;
      var facts = verifyCheckoutAuthority(cart);
      emit('bs_checkout_click', {
        drawer_state: lastRenderedState,
        cart_total: cart.total_price,
        cart_item_count: cart.item_count,
        preset_or_custom: facts.preset ? 'preset' : (facts.hiddenCount ? 'custom_set' : (facts.eligibleCount === 2 ? 'standalone_pair' : 'ordinary'))
      }, 'checkout:' + cart.token + ':' + cart.total_price + ':' + cart.item_count);
      sessionStorage.removeItem('bs_white_drawer_open');
      location.assign('/checkout');
    }).catch(function (error) {
      return getCart().then(function (cart) {
        latestCart = cart;
        renderRecoverableError(error, cart);
      }).catch(function () { renderRecoverableError(error); });
    }).finally(function () {
      mutationPending = false;
      setMutationBusy(false);
    });
  }

  // Compatibility stubs for feature-flagged custom-pair code. Delegation owns all live actions.
  function bindLineActions() {}
  function bindCheckout() {}

  function primaryForm() {
    var forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
    return forms.find(function (form) {
      return visibleSubmit(form) !== null;
    }) || null;
  }

  function visibleSubmit(form) {
    return Array.from(form.querySelectorAll('button[type="submit"],input[type="submit"]')).find(function (control) {
      return control.offsetParent !== null;
    }) || null;
  }

  function setFormVariant(form, variantId) {
    form.dataset.bsSelectedVariant = String(variantId);
    form.querySelectorAll('[name="id"]').forEach(function (input) {
      input.value = String(variantId);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function injectProductSelector() {
    if (!CUSTOM_PAIR_PRODUCT_PAGE_SELECTOR_ENABLED) return;
    var kind = path === ROUTES.evo ? 'evo' : (path === ROUTES.vortex ? 'vortex' : '');
    if (!kind || document.querySelector('.bs-stage-first-selector')) return;
    if (!availabilityCheckedAt && !window.__bsStageAvailabilityLoading) {
      window.__bsStageAvailabilityLoading = true;
      refreshAvailability().catch(function () {}).then(function () {
        availabilityCheckedAt = availabilityCheckedAt || Date.now();
        window.__bsStageAvailabilityLoading = false;
        injectProductSelector();
      });
      return;
    }
    var form = primaryForm();
    if (!form) return;
    var submit = visibleSubmit(form);
    if (!submit) return;
    var choices = kind === 'evo' ? ELIGIBLE.filter(function (item) { return item.productId === 7513953566822; }) : ELIGIBLE.filter(function (item) { return item.product === 'Vortex'; });
    var initial = null;
    var wrap = document.createElement('div');
    wrap.className = 'bs-stage-first-selector';
    wrap.innerHTML = '<fieldset><legend>' + (kind === 'evo' ? 'Choose your EVO finish' : 'Choose your Vortex style') + '</legend><div class="bs-stage-first-options">' + choices.map(function (item) {
      return '<button class="bs-stage-first-choice" type="button" data-bs-first="' + item.variantId + '" aria-pressed="' + String(initial && initial.variantId === item.variantId) + '" ' + (item.available ? '' : 'disabled') + '>' +
        '<img src="' + item.image + '" alt=""><strong>' + escapeHtml(item.option) + '</strong><span class="bs-selected">SELECTED</span></button>';
    }).join('') + '</div></fieldset>';
    var offer = document.createElement('div');
    offer.className = 'bs-stage-offer';
    offer.innerHTML = '<p class="bs-stage-eyebrow">LIMITED-TIME 2-PITCHER OFFER</p><h3>Choose any 2 eligible pitchers for $119 and get the Latte Art Starter Kit FREE.</h3><p>Add this as your first pitcher. You’ll choose your second pitcher next at no extra cost.</p>';
    submit.parentNode.insertBefore(wrap, submit);
    submit.parentNode.insertBefore(offer, submit);
    submit.insertAdjacentHTML('afterend', '<span class="bs-stage-helper">Next: choose your second pitcher and complete your FREE Starter Kit offer.</span>');
    submit.textContent = kind === 'evo' ? 'ADD EVO 2.0 + CHOOSE SECOND PITCHER' : 'ADD VORTEX + CHOOSE SECOND PITCHER';
    submit.setAttribute('aria-label', submit.textContent);
    submit.disabled = true;
    wrap.querySelectorAll('[data-bs-first]').forEach(function (button) {
      button.addEventListener('click', function () {
        var selected = Number(button.dataset.bsFirst);
        wrap.querySelectorAll('[data-bs-first]').forEach(function (candidate) { candidate.setAttribute('aria-pressed', String(candidate === button)); });
        setFormVariant(form, selected);
        submit.disabled = false;
        emit('bs_first_variant_selected', { product_id: choices.find(function (item) { return item.variantId === selected; }).productId, variant_id: selected }, 'first:' + selected);
      });
    });
    function handleFirstAdd(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!form.dataset.bsSelectedVariant) {
        alert(kind === 'evo' ? 'Please choose your EVO finish.' : 'Please choose With Handle or No Handle.');
        return;
      }
      if (form.dataset.bsSubmitting === 'true') return;
      form.dataset.bsSubmitting = 'true';
      managedAddPending = true;
      submit.disabled = true;
      var previous = submit.textContent;
      submit.textContent = 'ADDING…';
      var selectedId = Number(form.dataset.bsSelectedVariant);
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: selectedId, quantity: 1 }] }) })
        .then(function (response) { if (!response.ok) throw new Error('The selected pitcher could not be added.'); return response.json(); })
        .then(function () {
          sessionStorage.setItem('bs_stage_post_add', '1');
          emit('bs_first_pitcher_added', { variant_id: selectedId }, 'first-add:' + selectedId + ':' + Date.now());
          openDrawer(submit);
        })
        .catch(function (error) {
          emit('bs_cart_state_error', { drawer_state: 'ERR', error_code: 'first_add_failed', variant_id: selectedId }, 'first-add-error:' + Date.now());
          alert(error.message);
        })
        .finally(function () { managedAddPending = false; form.dataset.bsSubmitting = 'false'; submit.disabled = false; submit.textContent = previous; });
    }
    submit.addEventListener('click', handleFirstAdd, true);
    form.addEventListener('submit', handleFirstAdd, true);
    emit('bs_offer_view', { product_id: choices[0].productId, variant_id: null }, 'offer:' + kind);
  }

  function bindBundleAdd() {
    if (path !== ROUTES.bundle) return;
    var form = primaryForm();
    if (!form || form.dataset.bsPresetBound === 'true') return;
    var submit = visibleSubmit(form);
    if (!submit) return;
    form.dataset.bsPresetBound = 'true';
    function handlePresetAdd(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.dataset.bsSubmitting === 'true') return;
      var idInput = form.querySelector('[name="id"]');
      var selectedId = idInput ? Number(idInput.value) : 0;
      if (PRESET_VARIANTS.indexOf(selectedId) === -1) {
        alert('Please choose an EVO finish before adding the set.');
        return;
      }
      form.dataset.bsSubmitting = 'true';
      managedAddPending = true;
      submit.disabled = true;
      var previous = submit.textContent;
      submit.textContent = 'ADDING…';
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: selectedId, quantity: 1 }] }) })
        .then(function (response) { if (!response.ok) throw new Error('The complete set could not be added.'); return response.json(); })
        .then(getCart)
        .then(reconcileStarterKitAuthority)
        .then(function (verifiedCart) {
          if (!cartFacts(verifiedCart).presetKitVerified) throw new Error('The real $0 Starter Kit could not be verified.');
          sessionStorage.setItem('bs_stage_post_add', '1');
          emit('bs_first_pitcher_added', { product_id: PRESET_PRODUCT_ID, variant_id: selectedId, preset_or_custom: 'preset', preset_quantity: cartFacts(verifiedCart).presetQuantity, kit_quantity: cartFacts(verifiedCart).presetKitQuantity }, 'preset-add:' + selectedId + ':' + Date.now());
          openDrawer(submit);
        })
        .catch(function (error) {
          emit('bs_cart_state_error', { drawer_state: 'ERR', error_code: 'preset_add_failed', variant_id: selectedId }, 'preset-add-error:' + Date.now());
          alert(error.message);
        })
        .finally(function () { managedAddPending = false; form.dataset.bsSubmitting = 'false'; submit.disabled = false; submit.textContent = previous; });
    }
    submit.addEventListener('click', handlePresetAdd, true);
    form.addEventListener('submit', handlePresetAdd, true);
  }

  function injectContract() {
    // Product-page commercial copy is already owned by the current premium templates.
    // Keeping this as a no-op prevents the retired black engine from injecting a second contract.
    return;
  }

  function styleBundlePromise() {
    if (path !== ROUTES.bundle) return;
    var heroHeadings = Array.from(document.querySelectorAll('h1,h2,h3')).filter(function (element) {
      return /Better (?:Microfoam\s*&\s*Latte Art|Latte Art).*21 Days.*Money Back/i.test(element.textContent || '');
    });
    heroHeadings.forEach(function (heroHeading) {
      if (!heroHeading.querySelector('.bs-money-back')) heroHeading.innerHTML = 'Try your pitcher for 21 days.';
    });
    var elements = Array.from(document.querySelectorAll('h1,h2,h3,h4,p,div,span')).filter(function (element) {
      return element.children.length === 0 && /Try the products for at least 21 days/i.test(element.textContent || '') && /or your money back/i.test(element.textContent || '');
    });
    var target = elements[0];
    if (!target || target.querySelector('.bs-money-back')) return;
    var text = target.textContent.trim();
    var parts = text.split(/or your money back\.?/i);
    target.innerHTML = escapeHtml(parts[0].trim()) + ' <span class="bs-money-back">or your money back.</span>';
  }

  function correctScopedCopy() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      if (/No extra costs at checkout/i.test(node.nodeValue || '')) node.nodeValue = 'Worldwide shipping included';
      if (/EU final price/i.test(node.nodeValue || '')) node.nodeValue = '🇪🇺 EU: Shipping included; VAT calculated and added at checkout';
      if (/US:\s*\$119 final price, with shipping, customs and duties included/i.test(node.nodeValue || '')) node.nodeValue = 'US: $119 final price, with shipping, taxes, customs and duties included';
      if (/EU:\s*Shipping included; VAT added at checkout/i.test(node.nodeValue || '')) node.nodeValue = 'EU: Shipping included; VAT calculated and added at checkout';
      if (/21-day money-back guarantee\s*·\s*Free return shipping/i.test(node.nodeValue || '')) node.nodeValue = 'Pitcher satisfaction promise · Free return shipping';
      if (/^\s*21-day money-back guarantee\s*$/i.test(node.nodeValue || '')) node.nodeValue = 'Pitcher satisfaction promise';
      if (/US\s*&\s*Australia:\s*Free express shipping\.\s*No customs or import taxes\.?/i.test(node.nodeValue || '')) node.nodeValue = 'Worldwide shipping included';
      if (/US\s*&\s*Australia:\s*Free express shipping\.\s*No import taxes due\.?/i.test(node.nodeValue || '')) node.nodeValue = 'Worldwide shipping included';
      if (/^\s*No Surprise Costs\s*$/i.test(node.nodeValue || '')) node.nodeValue = 'Delivery & Returns';
      if (/^\s*✓?\s*Free express shipping\s*$/i.test(node.nodeValue || '')) node.nodeValue = '✓ Worldwide shipping included';
      if (/^\s*✓?\s*(?:No customs\/?import taxes|US duties & import taxes included)\s*$/i.test(node.nodeValue || '')) node.nodeValue = '✓ Regional terms below';
      if (/^\s*✓?\s*Free returns\s*$/i.test(node.nodeValue || '')) node.nodeValue = '✓ Free return shipping';
      if (/^\s*Free Express\s*$/i.test(node.nodeValue || '')) node.nodeValue = 'Worldwide';
      if (/^\s*No Customs\.?\s*$/i.test(node.nodeValue || '')) node.nodeValue = 'Worldwide';
      if (/^\s*No Import Taxes\.?\s*$/i.test(node.nodeValue || '')) node.nodeValue = 'Shipping Included';
    });
    document.querySelectorAll('h1,h2,h3,h4,p').forEach(function (element) {
      if (/30-day money-back guarantee/i.test(element.textContent || '')) {
        element.textContent = 'Use your pitcher for at least 21 days. Contact us within 45 days of delivery. Eligible satisfaction returns ship back free for a full refund.';
      }
    });
  }

  function normalizeProductGuarantee() {
    if (path !== ROUTES.evo && path !== ROUTES.vortex) return;
    var normalizedHeading = 'Try your pitcher for 21 days.';
    document.querySelectorAll('h1,h2,h3,h4').forEach(function (heading) {
      if (/Better (?:Microfoam\s*&\s*Latte Art|Milk Texture|Latte Art).*21 Days.*Money Back/i.test(heading.textContent || '')) {
        // Setting textContent to the same string still creates a child-list
        // mutation. The global observer calls this function after drawer
        // renders, so this equality guard prevents a self-triggering loop.
        if (heading.textContent.trim() !== normalizedHeading) heading.textContent = normalizedHeading;
      }
    });
  }

  function enhanceSelectorFallback() {
    if (!CUSTOM_PAIR_PRODUCT_PAGE_SELECTOR_ENABLED) return;
    if (path !== ROUTES.selector || document.getElementById('bs-stage-selector-copy')) return;
    var block = document.createElement('section');
    block.id = 'bs-stage-selector-copy';
    block.className = 'bs-stage-contract';
    var main = document.querySelector('main') || document.body;
    main.insertBefore(block, main.firstChild);
    document.body.classList.add('bs-stage-commerce-active');
    document.body.classList.add('bs-stage-selector-active');
    Promise.all([getCart(), refreshAvailability()]).then(function (results) {
      var cart = results[0];
      var facts = cartFacts(cart);
      if (facts.hiddenCount) {
        block.innerHTML = '<p class="bs-stage-eyebrow">COMPLETE $119 SET</p><h1 class="bs-stage-title">Your set is ready.</h1><p class="bs-stage-copy">Review both pitchers and the FREE Starter Kit in your cart.</p><button class="bs-stage-action" type="button" data-bs-open-cart>REVIEW MY COMPLETE SET</button>';
        block.querySelector('[data-bs-open-cart]').addEventListener('click', function () { openDrawer(this); });
        return;
      }
      if (facts.eligibleCount !== 1) {
        block.innerHTML = '<h1 class="bs-stage-title">Choose Your Second Pitcher</h1><p class="bs-stage-copy">Add your first eligible pitcher before completing the $119 set.</p><button class="bs-stage-action" type="button" data-bs-open-cart>REVIEW MY CART</button>';
        block.querySelector('[data-bs-open-cart]').addEventListener('click', function () { openDrawer(this); });
        return;
      }
      block.innerHTML = '<p class="bs-stage-eyebrow">COMPLETE YOUR $119 SET</p><h1 class="bs-stage-title">Choose Your Second Pitcher</h1><p class="bs-stage-copy">Your second eligible pitcher and Latte Art Starter Kit are included in the $119 set.</p><div class="bs-stage-options">' + SECOND_OPTIONS.map(function (item) {
        return '<button class="bs-stage-option" type="button" data-bs-selector-second="' + item.variantId + '" ' + (item.available ? '' : 'disabled') + '><img src="' + item.image + '" alt=""><strong>' + escapeHtml(item.product) + '</strong><small>' + escapeHtml(item.option) + (item.available ? ' · Available' : ' · Sold out') + '</small></button>';
      }).join('') + '</div><button class="bs-stage-action" type="button" data-bs-selector-complete disabled>SELECT A SECOND PITCHER</button>';
      var chosen = null;
      block.querySelectorAll('[data-bs-selector-second]').forEach(function (choice) {
        choice.addEventListener('click', function () {
          chosen = Number(choice.dataset.bsSelectorSecond);
          block.querySelectorAll('[data-bs-selector-second]').forEach(function (candidate) { candidate.setAttribute('aria-pressed', String(candidate === choice)); });
          var item = eligibleById(chosen);
          var action = block.querySelector('[data-bs-selector-complete]');
          action.disabled = false;
          action.textContent = 'COMPLETE MY SET WITH ' + item.product.toUpperCase() + ' — ' + item.option.toUpperCase();
          emit('bs_second_pitcher_selected', { drawer_state: 'SELECTOR', second_variant_id: chosen }, 'selector:' + chosen);
        });
      });
      block.querySelector('[data-bs-selector-complete]').addEventListener('click', function () {
        if (!chosen) return;
        convertSingleToHiddenSet(facts.eligibleLines[0], chosen, this).then(function () { openDrawer(block.querySelector('[data-bs-selector-complete]')); });
      });
    }).catch(function (error) {
      block.innerHTML = '<div class="bs-stage-error">' + escapeHtml(error.message) + '</div><button class="bs-stage-action" type="button" data-bs-open-cart>REVIEW MY CART</button>';
      block.querySelector('[data-bs-open-cart]').addEventListener('click', function () { openDrawer(this); });
    });
  }


  function selectorFullCartGroup(row, cart) {
    var setup = row && row.getAttribute('data-bs-selector-setup');
    var parentId = row && Number(row.getAttribute('data-bs-selector-parent'));
    return selectorGroups(cart).find(function (group) { return group.setup === setup && group.parentId === parentId; });
  }

  function enhanceSelectorFullCart(cart) {
    if (path !== ROUTES.cart) return;
    latestCart = cart;
    var rows = Array.from(document.querySelectorAll('[data-cart-form="cart-template"] [data-cart-item][data-line-id]'));
    function rowFor(line) {
      var index = cart.items.indexOf(line);
      return rows.find(function (row) { return Number(row.getAttribute('data-line-id')) === index + 1 && Number(row.getAttribute('data-variant-id')) === Number(line.variant_id); });
    }
    selectorGroups(cart).forEach(function (group) {
      if (!Number.isSafeInteger(group.quantity) || !group.parents.length) return;
      var row = rowFor(group.parents[0]);
      if (!row) return;
      row.setAttribute('data-bs-selector-setup', group.setup);
      row.setAttribute('data-bs-selector-parent', String(group.parentId));
      var title = row.querySelector('.cart__item--title a');
      if (title) title.textContent = group.setup === SELECTOR_VORTEX_SETUP ? selectorCopy.pairTitle : selectorCopy.ultraTitle;
      var input = row.querySelector('input[name="updates[]"]');
      if (input) {
        input.value = String(group.quantity);
        input.defaultValue = String(group.quantity);
        input.setAttribute('aria-label', title ? title.textContent + ' quantity' : 'Setup quantity');
        if (input.hasAttribute('max') && group.setup === SELECTOR_VORTEX_SETUP) input.max = String(Math.floor(Number(input.max) / 2));
      }
      var price = row.querySelector('.modal_price');
      if (price && group.quantity) price.textContent = money(group.total / group.quantity, cart.currency);
      var total = row.querySelector('.price_total');
      if (total) Array.from(total.querySelectorAll('.money')).forEach(function (amount, index) {
        amount.hidden = index > 0;
        if (!index) { amount.classList.remove('was_price'); amount.textContent = money(group.total, cart.currency); }
      });
      group.parents.slice(1).concat(group.kits).forEach(function (line) {
        var included = rowFor(line);
        if (included) { included.hidden = true; included.style.setProperty('display', 'none', 'important'); }
      });
    });
    bindSelectorFullCart();
  }

  function selectorFullCartUpdate(row, quantity, trigger) {
    if (mutationPending || !Number.isSafeInteger(quantity) || quantity < 0) return;
    var input = row.querySelector('input[name="updates[]"]');
    var previousQuantity = input && Number(input.defaultValue);
    var form = row.closest('form');
    mutationPending = true;
    var controls = Array.from(form.querySelectorAll('input,button')).map(function (control) { var previous = control.disabled; control.disabled = true; return { control: control, previous: previous }; });
    getCart().then(function (cart) {
      var group = selectorFullCartGroup(row, cart);
      if (!group || group.quantity !== previousQuantity) throw new Error('Your cart changed. Refresh it before changing quantities and checking out.');
      return selectorGroupChange(group, quantity);
    }).then(getCart).then(reconcileStarterKitAuthority).then(function (cart) {
      verifyCheckoutAuthority(cart);
      var group = selectorFullCartGroup(row, cart);
      if (quantity ? !group || group.quantity !== quantity : group && group.quantity) throw new Error('Your requested quantity could not be saved. Review your cart before checkout.');
      location.reload();
    }).catch(function (error) {
      if (input) input.value = input.defaultValue;
      return openDrawer(trigger, 'Cart needs attention').then(function () { if (latestCart) renderRecoverableError(error, latestCart); });
    }).finally(function () {
      mutationPending = false;
      controls.forEach(function (saved) { saved.control.disabled = saved.previous; });
    });
  }

  function bindSelectorFullCart() {
    if (document.documentElement.getAttribute('data-bs-selector-fullcart-bound') === 'true') return;
    document.documentElement.setAttribute('data-bs-selector-fullcart-bound', 'true');
    function handle(event) {
      var form = event.target.closest('[data-cart-form="cart-template"]');
      if (!form) return;
      if (mutationPending) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      var row = event.target.closest('[data-bs-selector-setup][data-bs-selector-parent]');
      if (!row) return;
      var input = row.querySelector('input[name="updates[]"]');
      var control = event.type === 'click' && event.target.closest('.js-change-quantity,[data-remove-item]');
      if (event.type === 'change' ? event.target !== input : !control) return;
      event.preventDefault(); event.stopImmediatePropagation();
      var quantity = Number(input.value);
      if (control) quantity = control.hasAttribute('data-remove-item') ? 0 : quantity + (control.getAttribute('data-func') === 'plus' ? 1 : -1);
      selectorFullCartUpdate(row, quantity, control || input);
    }
    window.addEventListener('click', handle, true);
    window.addEventListener('change', handle, true);
  }

  function commitFullCartQuantities(form) {
    var edits = [];
    if (form) Array.from(form.querySelectorAll('[data-bs-selector-setup][data-bs-selector-parent] input[name="updates[]"]')).forEach(function (input) {
      if (input.value === input.defaultValue) return;
      if (!/^\d+$/.test(input.value) || !Number.isSafeInteger(Number(input.value))) throw new Error('Please enter a valid quantity or refresh your cart before checkout.');
      edits.push({ row: input.closest('[data-bs-selector-setup]'), quantity: Number(input.value), previous: Number(input.defaultValue) });
    });
    return commitNativeFullCartQuantities(form).then(function (cart) {
      return edits.reduce(function (pending, edit) {
        return pending.then(function (current) {
          var group = selectorFullCartGroup(edit.row, current);
          if (!group || group.quantity !== edit.previous) throw new Error('Your cart changed. Refresh it before changing quantities and checking out.');
          return selectorGroupChange(group, edit.quantity).then(getCart).then(function (saved) {
            var result = selectorFullCartGroup(edit.row, saved);
            if (edit.quantity ? !result || result.quantity !== edit.quantity : result && result.quantity) throw new Error('Your requested quantity could not be saved. Review your cart before checkout.');
            return saved;
          });
        });
      }, Promise.resolve(cart));
    });
  }

  function commitNativeFullCartQuantities(form) {
    var pending = [];
    if (form) Array.from(form.querySelectorAll('input[name="updates[]"]')).forEach(function (input) {
      if (input.disabled || !input.getClientRects().length || input.value === input.defaultValue) return;
      var row = input.closest('[data-cart-item][data-variant-id]');
      if (row && row.hasAttribute('data-bs-selector-setup')) return;
      var variantId = row && Number(row.getAttribute('data-variant-id'));
      var quantity = Number(input.value);
      var previousQuantity = Number(input.defaultValue);
      if (!variantId || !/^\d+$/.test(input.value) || !Number.isSafeInteger(quantity) ||
          !Number.isSafeInteger(previousQuantity) || previousQuantity < 0) {
        throw new Error('Please enter a valid quantity or refresh your cart before checkout.');
      }
      pending.push({ variantId: variantId, quantity: quantity, previousQuantity: previousQuantity });
    });
    return getCart().then(function (cart) {
      var updates = {};
      var seen = {};
      pending.forEach(function (edit) {
        var matches = cart.items.filter(function (item) { return Number(item.variant_id) === edit.variantId; });
        if (seen[edit.variantId] || matches.length !== 1 || !matches[0].key) {
          throw new Error('Your cart changed. Refresh it before changing quantities and checking out.');
        }
        seen[edit.variantId] = true;
        var item = matches[0];
        if (Number(item.quantity) === edit.quantity) return;
        if (Number(item.quantity) !== edit.previousQuantity) {
          throw new Error('Your cart changed. Refresh it before changing quantities and checking out.');
        }
        updates[item.key] = edit.quantity;
      });
      if (!Object.keys(updates).length) return cart;
      return updateCartLines(updates).then(function (saved) {
        pending.forEach(function (edit) {
          var matches = saved.items.filter(function (item) { return Number(item.variant_id) === edit.variantId; });
          if (edit.quantity === 0 ? matches.length !== 0 :
              matches.length !== 1 || Number(matches[0].quantity) !== edit.quantity) {
            throw new Error('Your requested quantity could not be saved. Review your cart before checkout.');
          }
        });
        return saved;
      });
    });
  }

  function bindFullCartCheckoutGuard() {
    if (path !== ROUTES.cart || document.documentElement.getAttribute('data-bs-cart-checkout-guard') === 'true') return;
    document.documentElement.setAttribute('data-bs-cart-checkout-guard', 'true');
    window.addEventListener('click', function (event) {
      var trigger = event.target.closest('button[name="checkout"],#checkout');
      if (!trigger || mutationPending) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      mutationPending = true;
      trigger.disabled = true;
      var previous = trigger.textContent;
      trigger.textContent = 'Checking cart…';
      Promise.resolve().then(function () {
        return commitFullCartQuantities(trigger.form || trigger.closest('form'));
      }).then(reconcileStarterKitAuthority).then(function (cart) {
        latestCart = cart;
        verifyCheckoutAuthority(cart);
        sessionStorage.removeItem('bs_white_drawer_open');
        location.assign('/checkout');
      }).catch(function (error) {
        return openDrawer(trigger, 'Cart needs attention').then(function () {
          if (latestCart) renderRecoverableError(error, latestCart);
        }).catch(function () { alert(error.message); });
      }).finally(function () {
        mutationPending = false;
        trigger.disabled = false;
        trigger.textContent = previous;
      });
    }, true);
  }

  function enhanceCartPage() {
    if (path !== ROUTES.cart || document.getElementById('bs-stage-cart-contract')) return;
    var pageCheckout = document.querySelector('button[name="checkout"],#checkout');
    var pageCheckoutGroup = pageCheckout && pageCheckout.closest('.checkout_button');
    var pageCartSummary = pageCheckout && pageCheckout.closest('.subtotal');
    syncEuVatNotice(pageCartSummary, pageCheckoutGroup || pageCheckout);
    var beforeFacts = null;
    getCart().then(function (beforeCart) {
      beforeFacts = cartFacts(beforeCart);
      return reconcileStarterKitAuthority(beforeCart);
    }).then(function (cart) {
      var afterFacts = cartFacts(cart);
      if (beforeFacts && beforeFacts.starterKitCount !== afterFacts.starterKitCount) {
        location.reload();
        return null;
      }
      return cart;
    }).then(function (cart) {
      if (!cart) return;
      enhanceSelectorFullCart(cart);
      var facts = cartFacts(cart);
      var nativeOffer = Array.from(document.querySelectorAll('strong')).find(function (element) {
        return /Buy any 2 pitchers for \$119 total/i.test(element.textContent || '');
      });
      if (nativeOffer) {
        if (facts.preset) nativeOffer.textContent = 'Complete set: $119 each ✓';
        else if (facts.eligibleCount === 2 && facts.pairDiscountApplied) nativeOffer.textContent = 'Shopify two-pitcher discount applied ✓';
        else if (facts.eligibleCount === 2) nativeOffer.textContent = 'Two standalone pitchers · verify the total below';
        else if (facts.eligibleCount === 1) nativeOffer.textContent = 'Add a second eligible pitcher to activate the Shopify offer';
        else if (nativeOffer.parentElement) nativeOffer.parentElement.hidden = true;
      }
      var block = document.createElement('section');
      block.id = 'bs-stage-cart-contract';
      block.className = 'bs-cart-page-contract';
      if (facts.preset) {
        block.innerHTML = '<strong>' + (facts.mixedPreset ? 'Bundle price: $119 each' : (facts.presetQuantity > 1 ? facts.presetQuantity + ' complete sets · $119 each' : 'Complete latte art set · $119')) + '</strong>' +
          '<p>Worldwide shipping included. Use your pitcher for at least 21 days. Contact us within 45 days of delivery. Eligible satisfaction returns ship back free for a full refund.</p>' +
          '<p>Actual cart total: <strong>' + money(cart.total_price, cart.currency) + '</strong></p>';
      } else if (facts.eligibleCount === 2) {
        block.innerHTML = '<strong>Two standalone pitchers</strong>' +
          '<p>' + (facts.pairDiscountApplied ? 'Shopify discount applied: ' + escapeHtml(facts.pairDiscountTitles.join(' · ')) + ' (saving ' + money(facts.pairDiscountAmount, cart.currency) + ').' : 'No BOGOALL allocation is present in the current Shopify cart.') + '</p>' +
          '<p>Actual cart total: <strong>' + money(cart.total_price, cart.currency) + '</strong>. This total covers the standalone pitcher lines shown above.</p>';
      } else if (facts.eligibleCount === 1) {
        block.innerHTML = '<strong>One eligible pitcher in your cart</strong><p>Open the cart drawer to see currently available second-pitcher options. Shopify will determine the discount and final total.</p>';
      } else return;
      var checkoutButton = document.querySelector('button[name="checkout"],#checkout');
      var checkoutGroup = checkoutButton && checkoutButton.closest('.checkout_button');
      var cartSummary = checkoutButton && checkoutButton.closest('.subtotal');
      var main = document.querySelector('main') || document.body;
      if (cartSummary) cartSummary.insertBefore(block, checkoutGroup || checkoutButton);
      else main.appendChild(block);
    }).catch(function () {});
    document.body.classList.add('bs-stage-commerce-active');
  }

  function cartTriggerSelector() {
    return 'a[href="/cart"],a[href$="/cart"],[data-cart-trigger],[data-cart-drawer-trigger],[data-action="open-mini-cart"],.mini_cart,.js-drawer-open-cart,button[aria-controls="cart-drawer"]';
  }

  function interceptHeaderCart() {
    window.addEventListener('click', function (event) {
      var trigger = event.target.closest(cartTriggerSelector());
      if (!trigger || path === ROUTES.cart) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      openDrawer(trigger);
    }, true);
  }

  function bindHeaderCartLinks() {
    if (path === ROUTES.cart) return;
    document.querySelectorAll(cartTriggerSelector()).forEach(function (trigger) {
      if (trigger.getAttribute('data-bs-stage-cart-bound') === 'true') return;
      trigger.setAttribute('data-bs-stage-cart-bound', 'true');
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openDrawer(trigger);
      }, true);
    });
  }

  function interceptCartRequests() {
    var nativeFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      return nativeFetch.apply(this, args).then(function (response) {
        if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(url) && response.ok && !managedKitReconcilePending) {
          sessionStorage.setItem('bs_stage_post_add', '1');
          setTimeout(function () { if (!managedAddPending && !mutationPending && !document.querySelector('[data-bs-selected-variant]') && !document.querySelector('#bs-cart-drawer-root[aria-hidden="false"]')) openDrawer(document.activeElement); }, 50);
        }
        return response;
      });
    };

    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__bsCartAddRequest = /\/cart\/add(?:\.js)?(?:\?|$)/.test(String(url || ''));
      return nativeOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__bsCartAddRequest) this.addEventListener('load', function () {
        if (this.status < 200 || this.status >= 300) return;
        sessionStorage.setItem('bs_stage_post_add', '1');
        setTimeout(function () {
          if (!managedAddPending && !mutationPending && !document.querySelector('#bs-cart-drawer-root[aria-hidden="false"]')) openDrawer(document.activeElement);
        }, 50);
      }, { once: true });
      return nativeSend.apply(this, arguments);
    };
  }

  // CRO-001: identity-based single upgrade; the existing reconciler remains authoritative.
  var CRO_SINGLE_IDS = [48946539331686,48946539364454,48946539397222,48946539429990];
  function croConfig() {
    var el = document.getElementById('bs-cro-commerce-data');
    try { return el ? JSON.parse(el.textContent) : {}; } catch (_) { return {}; }
  }
  function croStockMessage(id) {
    // This is the selected SYSTEM allocation, not a sum of overlapping physical SKUs.
    var entry = (croConfig().systems || []).find(function(v){return Number(v.id)===Number(id);});
    if (!entry || !entry.tracked || entry.policy!=='deny' || !entry.available || !Number.isInteger(entry.quantity) || entry.quantity<1 || entry.quantity>25) return '';
    return 'Low stock: '+entry.quantity+' '+entry.title+' systems available';
  }
  function croProductProof(id) {
    var system = PRESET_VARIANTS.indexOf(Number(id))!==-1;
    var evo = [48946539331686,48946539364454,45535715033190,42373983174758].indexOf(Number(id))!==-1;
    var vortex = [48946539397222,48946539429990,44451453567078,45391169683558].indexOf(Number(id))!==-1;
    if (!system && !evo && !vortex) return '';
    var text, name, product;
    if (system) {
      text = 'They offer great control over your art, feel nice to hold and look cool.';
      name = 'Adam F.'; product = 'EVO 2.0 review; purchased EVO + Vortex';
    } else if (evo) {
      text = 'it’s like a paint brush for latte art!';
      name = 'Joe R.'; product = 'EVO 2.0';
    } else {
      text = 'The vortex created in it is much faster than a conventional pitcher.';
      name = 'Shawn J.'; product = 'Vortex';
    }
    return '<div class="bs-cro-proof"><span class="bs-cro-stars" aria-label="5 out of 5 stars">★★★★★</span><p>“'+escapeHtml(text)+'”</p><small>Verified buyer · '+name+' · '+product+'</small><small>Review earned a reward for a future purchase. <a href="/pages/reviews">Read reviews</a></small></div>';
  }
  function croSingleCandidate(cart) {
    var singles = (cart.items||[]).filter(function(l){return CRO_SINGLE_IDS.indexOf(Number(l.variant_id))!==-1;});
    if (singles.length!==1 || Number(singles[0].quantity)!==1 || singles[0].selling_plan_allocation) return null;
    var facts=cartFacts(cart);
    if (facts.presetQuantity || facts.eligibleCount || facts.hiddenCount || facts.starterKitCount) return null;
    return singles[0];
  }
  function croUpgradeHtml(cart) {
    var line=croSingleCandidate(cart); if (!line) return '';
    var id=Number(line.variant_id), isEvo=id===CRO_SINGLE_IDS[0]||id===CRO_SINGLE_IDS[1];
    var target=id===CRO_SINGLE_IDS[0]?PRESET_VARIANTS[1]:PRESET_VARIANTS[0];
    var text=isEvo?'Add Vortex With Handle + the 3-piece starter kit. Your EVO finish is preserved.':id===CRO_SINGLE_IDS[3]?'Switch to Vortex With Handle + EVO 2.0 + the 3-piece starter kit.':'Add EVO 2.0 + the 3-piece starter kit.';
    var difference=marketCode()==='US'&&cart.currency==='USD'&&cart.items.length===1&&Number(line.final_line_price)===6999&&Number(cart.total_price)===6999&&!Number(cart.total_discount);
    emit('bs_cart_upgrade_impression',{single_variant_id:id,target_variant_id:target},'cro-upgrade-view:'+id);
    return '<div class="bs-cro-upgrade"><p class="bs-cart-eyebrow">COMPLETE YOUR LATTE ART SYSTEM</p><strong>Both pitchers. All three accessories. $119.</strong><p>'+text+' Worldwide shipping included.</p>'+
      (!isEvo?'<label>EVO finish<select data-bs-upgrade-finish><option value="'+PRESET_VARIANTS[0]+'">Mirror Multicolor</option><option value="'+PRESET_VARIANTS[1]+'">Mirror Black</option></select></label>':'')+
      (difference?'<p><strong>$39.02 more delivered in the U.S.</strong></p>':'')+
      '<button class="bs-stage-action" type="button" data-bs-upgrade-single data-bs-key="'+escapeHtml(line.key)+'" data-bs-system="'+target+'">UPGRADE TO COMPLETE SYSTEM →</button></div>';
  }
  function croUpgradeRequest(url,body) {
    var controller=new AbortController();
    var timer=setTimeout(function(){controller.abort();},12000);
    return fetch(url,{method:body?'POST':'GET',credentials:'same-origin',signal:controller.signal,headers:{'Content-Type':'application/json',Accept:'application/json'},body:body?JSON.stringify(body):undefined})
      .then(function(r){return r.json().then(function(data){if(!r.ok)throw new Error(data.description||'The cart could not be updated.');return data;});})
      .finally(function(){clearTimeout(timer);});
  }
  function croWaitForAuthority(promise) {
    return new Promise(function(resolve,reject){
      var timer=setTimeout(function(){var e=new Error('The cart is still updating. Refresh it before continuing.');e.name='AuthorityTimeout';reject(e);},15000);
      promise.then(function(value){clearTimeout(timer);resolve(value);},function(error){clearTimeout(timer);reject(error);});
    });
  }
  function croUnchangedOtherLines(before,after,singleKey,addedKey) {
    function rest(cart){return cart.items.filter(function(l){return l.key!==singleKey&&l.key!==addedKey&&Number(l.variant_id)!==STARTER_KIT_VARIANT_ID;}).map(function(l){return l.key+':'+l.quantity;}).sort().join('|');}
    return rest(before)===rest(after);
  }
  async function croUpgradeSingle(button) {
    if (mutationPending) return;
    mutationPending=true;setMutationBusy(true);button.disabled=true;
    var before,source,attempt='cro001-'+Date.now(),target,addedKey='',completed=false;
    try {
      before=await croUpgradeRequest('/cart.js'); source=croSingleCandidate(before);
      if(!source||source.key!==button.getAttribute('data-bs-key'))throw new Error('Your cart changed. Refresh it before upgrading.');
      var select=button.closest('.bs-cro-upgrade').querySelector('[data-bs-upgrade-finish]');
      target=Number(select?select.value:button.getAttribute('data-bs-system'));
      if(PRESET_VARIANTS.indexOf(target)===-1)throw new Error('Choose a supported EVO finish.');
      if(Number(source.variant_id)===CRO_SINGLE_IDS[0]&&target!==PRESET_VARIANTS[1] || Number(source.variant_id)===CRO_SINGLE_IDS[1]&&target!==PRESET_VARIANTS[0])throw new Error('The selected EVO finish changed.');
      emit('bs_cart_upgrade_click',{single_variant_id:Number(source.variant_id),system_variant_id:target},attempt);
      await croUpgradeRequest('/cart/add.js',{items:[{id:target,quantity:1,properties:{_cro001_offer:'system',_cro001_upgrade:attempt}}]});
      var added=await croUpgradeRequest('/cart.js');
      var newLines=added.items.filter(function(l){return Number(l.variant_id)===target&&l.properties&&l.properties._cro001_upgrade===attempt;});
      if(newLines.length!==1||newLines[0].quantity!==1||Number(newLines[0].original_price)!==11900)throw new Error('The system could not be verified.');
      addedKey=newLines[0].key;
      var unchangedSource=added.items.find(function(l){return l.key===source.key&&l.quantity===1;});
      if(!unchangedSource||!croUnchangedOtherLines(before,added,source.key,addedKey))throw new Error('The cart changed during the upgrade.');
      await croUpgradeRequest('/cart/change.js',{id:source.key,quantity:0});
      var finalCart=await croWaitForAuthority(reconcileStarterKitAuthority(await croUpgradeRequest('/cart.js')));
      var facts=verifyCheckoutAuthority(finalCart);
      if(finalCart.items.some(function(l){return l.key===source.key;})||facts.presetQuantity!==1||facts.presetKitQuantity!==1||!croUnchangedOtherLines(before,finalCart,source.key,addedKey))throw new Error('Please review the cart before checkout.');
      emit('bs_cart_upgrade_success',{single_variant_id:Number(source.variant_id),system_variant_id:target,cart_total:finalCart.total_price,currency:finalCart.currency},attempt);
      await croWaitForAuthority(renderDrawer());
      completed=true;
    } catch(error) {
      // Never remove another system or blindly restore a snapshot. If the original
      // single still exists, remove only this attempt's system and reconcile its kit.
      try {
        if(error.name==='AuthorityTimeout') throw error;
        var current=await croUpgradeRequest('/cart.js');
        var retained=source&&current.items.some(function(l){return l.key===source.key&&l.quantity===1;});
        var own=current.items.filter(function(l){return l.properties&&l.properties._cro001_upgrade===attempt;});
        if(retained&&own.length===1){await croUpgradeRequest('/cart/change.js',{id:own[0].key,quantity:0});current=await croUpgradeRequest('/cart.js');}
        current=await croWaitForAuthority(reconcileStarterKitAuthority(current));
        latestCart=current;renderRecoverableError(new Error(error.name==='AbortError'?'The update timed out. Review your cart before trying again.':error.message),current);
      } catch (_) {renderRecoverableError(new Error('The cart update could not be confirmed. Refresh the cart before continuing.'));}
      var nodes=drawerNodes();if(nodes)nodes.checkout.disabled=true;
      emit('bs_cart_upgrade_error',{error_code:completed?'render_failed':'upgrade_failed'},attempt);
    } finally {mutationPending=false;setMutationBusy(false);if(!completed){var n=drawerNodes();if(n)n.checkout.disabled=true;}}
  }
  function croEnhanceShell(nodes,cart,facts) {
    var single=(cart.items||[]).find(function(l){return CRO_SINGLE_IDS.indexOf(Number(l.variant_id))!==-1;});
    var productLine=facts.presetLines&&facts.presetLines[0]||single||facts.eligibleLines&&facts.eligibleLines[0];
    var proof=nodes.root.querySelector('[data-bs-product-proof]');
    if(proof){proof.innerHTML=productLine?croProductProof(productLine.variant_id):'';proof.hidden=!proof.innerHTML;}
    var stock=nodes.root.querySelector('[data-bs-stock]');
    if(stock){stock.textContent=productLine?croStockMessage(productLine.variant_id):'';stock.hidden=!stock.textContent;}
  }

  function boot() {
    injectStyles();
    initBundleMobileWhatsapp();
    if (wheelioSuppressedState()) suppressWheelio(document);
    suppressLegacyDrawer(document);
    bindLegacyCartClassGuards();
    ensureDrawer();
    interceptHeaderCart();
    bindHeaderCartLinks();
    interceptCartRequests();
    if (isPurchasePath) correctScopedCopy();
    if (isPurchasePath) normalizeProductGuarantee();
    if (isPurchasePath) enhanceSelectorFallback();
    bindFullCartCheckoutGuard();
    enhanceCartPage();
    if (isPurchasePath) styleBundlePromise();
    if (isPurchasePath) bindBundleAdd();
    if (isPurchasePath) injectProductSelector();
    if (sessionStorage.getItem('bs_white_drawer_open') === '1') openDrawer(document.activeElement);
    if (isPurchasePath) [300, 1200].forEach(function (delay) {
      setTimeout(function () { correctScopedCopy(); styleBundlePromise(); }, delay);
    });
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes && record.addedNodes.forEach(function (node) { if (node.nodeType === 1) { if (wheelioSuppressedState()) suppressWheelio(node); suppressLegacyDrawer(node); } });
      });
      bindLegacyCartClassGuards();
      if (isPurchasePath) injectProductSelector();
      bindHeaderCartLinks();
      if (isPurchasePath) styleBundlePromise();
      if (isPurchasePath) bindBundleAdd();
      if (isPurchasePath) normalizeProductGuarantee();
      initBundleMobileWhatsapp();
    }).observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('pageshow', function () {
      if (sessionStorage.getItem('bs_white_drawer_open') === '1') openDrawer(document.activeElement, 'Your cart');
    });
    window.addEventListener('popstate', function () {
      if (sessionStorage.getItem('bs_white_drawer_open') === '1') renderDrawer();
    });
    window.BaristaSwagCartDrawer = {
      productProof: croProductProof,
      stockMessage: croStockMessage,
      trackSelector: function(name,detail) { if(['bs_selector_impression','bs_selector_choice','bs_selector_pitcher','bs_selector_variant','bs_selector_add_success'].indexOf(name)!==-1) emit(name,detail,name==='bs_selector_impression'?'cro-pdp':String(Date.now())); },
      open: function () { return openDrawer(document.activeElement, 'Your cart'); },
      close: closeDrawer,
      refresh: renderDrawer,
      version: VERSION
    };
    document.dispatchEvent(new CustomEvent('bs:commerce-ready'));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
}());
